import React, { useEffect, useMemo, useRef, useState } from 'react';
import ShareIcon from '@mui/icons-material/Share';
import { CommentsCommponent } from './CommentsCommponent';
import 'react-datepicker/dist/react-datepicker.css';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import TextsmsIcon from '@mui/icons-material/Textsms';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Link, useParams } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import { useDispatch, useSelector } from 'react-redux';
import { GetActionsData_action, InsertNewAction_action } from '../Redux/Actions/Action_action';
import { Notify } from '../Utility/Notify';
import CircularProgress from '@mui/material/CircularProgress';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';

//leed preview
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

//icons for leed dialog
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import HistoryIcon from '@mui/icons-material/History';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import ManIcon from '@mui/icons-material/Man';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';

//comment dialog
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import {
  Autocomplete,
  Box,
  FormControlLabel,
  Switch,
  TextField,
  Tooltip,
  useTheme,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import SatelliteAltIcon from '@mui/icons-material/SatelliteAlt';
import NotesIcon from '@mui/icons-material/Notes';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import moment from 'moment';
import CachedIcon from '@mui/icons-material/Cached';
import InfoIcon from '@mui/icons-material/Info';
import { UpdateClientAction, UpdateStageToLeed } from '../Redux/Actions/UsersAction';
import RefreshIcon from '@mui/icons-material/Refresh';
import { AllCommentsCommponentMainShow } from './AllCommentsCommponentMainShow';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Get_All_Lead_Assigned_Data_Action } from '../Redux/Actions/Lead_Assigned_Action';
import axios from 'axios';
import { getToken } from 'firebase/messaging';
import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';
import WbIncandescentIcon from '@mui/icons-material/WbIncandescent';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';
import { db_url } from '../Api/BaseUrl';
import { GetAll_stage_Data, GetOne_stagetogettype_Data } from '../Redux/Actions/Stage_Action';
import { Insert_Lead_Stages_Data_Action } from '../Redux/Actions/Lead_Stages_Changed_Action';
import JSConfetti from 'js-confetti';

//=============================================================================================

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// firebaseConfig
const firebaseConfig = {
  apiKey: 'AIzaSyC7MKQ4GCj46rDtyVxMw-0W1kEHMjzrzj8',
  authDomain: 'homewalkers-1df5a.firebaseapp.com',
  projectId: 'homewalkers-1df5a',
  storageBucket: 'homewalkers-1df5a.firebasestorage.app',
  messagingSenderId: '107479182425',
  appId: '1:107479182425:web:0d46013d3c542dbb881548',
  measurementId: 'G-M8ZFNZ4XLM',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize FCM service
export const messaging = getMessaging(app);

export const ShowClientsActions2 = ({ user, leadid }) => {
  const theme = useTheme();
  const mode = theme.palette.mode;
  const dispatch = useDispatch();

  const [show, setShow] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [addActionEnabled, setAddActionEnabled] = useState(false);
  const [userlogin, setuserlogin] = useState('');
  const handleClose = () => {
    setShow(false);
    setIsChecked(false);
    setAddActionEnabled(false);
    resetStageForm();
  };
  const handleShow = () => setShow(true);

  //user login
  let userloginrealy = [];
  if (localStorage.getItem('user') !== null) {
    userloginrealy = JSON.parse(localStorage.getItem('user'));
  }

  // New state definitions
  const [selectedStage, setSelectedStage] = useState(null);
  const [showDateTimePicker, setShowDateTimePicker] = useState(false);
  const [stageType, setStageType] = useState(null);
  const lastDateRef = useRef(null);

  // States for Done Deal
  const [unitPrice, setUnitPrice] = useState('');
  const [isPriceValid, setIsPriceValid] = useState(false);
  const [unitnumber, setunitnumber] = useState('');
  const [isunitnumberValid, setisunitnumberValid] = useState(false);
  const [commissionRatio, setcommissionratio] = useState('');
  const [commissionratioValid, setIscommissionratioValid] = useState(false);
  const [totalCommission, setTotalCommission] = useState('');
  const [cahbackratiovalid, setiscashbackratiovalid] = useState(false);
  const [cashbackratio, setcashbackratio] = useState('');
  const [cashbackMoney, setCashbackMoney] = useState('');

  // States for EOI and Reservation
  const [eoiAmount, setEoiAmount] = useState('');
  const [reservationAmount, setReservationAmount] = useState('');
  const [isEoiAmountValid, setIsEoiAmountValid] = useState(false);
  const [isReservationAmountValid, setIsReservationAmountValid] = useState(false);

  // Switch state for Answer and No Answer
  const [answerNoAnswerSwitch, setAnswerNoAnswerSwitch] = useState(false);

  // Stages that need DateTimePicker
  const stagesWithDateTime = [
    'No Answer',
    'Answer',
    'Meeting',
    'Follow',
    'Follow After Meeting',
    'Follow Up',
    'Transfer',
    'Interested',
  ];

  // Function to generate automatic comments
  const generateAutoComments = (stageName) => {
    const commentTemplates = {
      Meeting: {
        firstComment: ``,
        secondComment: ``,
      },
      'Follow Up': {
        firstComment: ``,
        secondComment: ``,
      },
      'Follow After Meeting': {
        firstComment: ``,
        secondComment: ``,
      },
      Interested: {
        firstComment: ``,
        secondComment: ``,
      },
      'No Answer': {
        firstComment: 'اتصلت ومفيش رد',
        secondComment: 'هحاول تاني في وقت تاني',
      },
      Answer: {
        firstComment: 'رد عليا',
        secondComment: 'هكتب اللي قاله وهشوف هعمل ايه بعد كده',
      },
      Follow: {
        firstComment: ``,
        secondComment: ``,
      },
      Transfer: {
        firstComment: ``,
        secondComment: ``,
      },
      // اقتراحات زيادة:
      'New Lead': {
        firstComment: 'عميل جديد انضف لنا',
        secondComment: 'هبدأ اكلمه واعرف هو عايز ايه بالظبط',
      },
      Qualification: {
        firstComment: 'مرحلة التأهيل',
        secondComment: 'هقيمه واشوف يناسبنا ولا لا',
      },
      Presentation: {
        firstComment: 'عرضت عليه المنتج',
        secondComment: 'هتابع معاه واشوف رايه ايه',
      },
      Negotiation: {
        firstComment: 'دخلنا في تفاوض',
        secondComment: 'هتفاوض على السعر والشروط',
      },
      EOI: {
        firstComment: 'عمل ايه او اي',
        secondComment: 'هتابع معاه عشان يكمل الاجراءات ويدفع',
      },
      Reservation: {
        firstComment: 'حجز',
        secondComment: 'هتابع استكمال الحجز والدفعات',
      },
      'Done Deal': {
        firstComment: 'الصفقه تمت يا فندم',
        secondComment: 'هخلص الاجراءات واسلمه المنتج',
      },
      Lost: {
        firstComment: 'العميل مش هيشتري',
        secondComment: 'هحلل السبب واتعلم للصفقات الجاية',
      },
      Hot: {
        firstComment: 'العميل دافي جدا',
        secondComment: 'هضغط عليه عشان يكمل عشان متفلش الصفقه',
      },
      Warm: {
        firstComment: 'العميل لسه محتاج شوية',
        secondComment: 'هفضل اتابع معاه لحد ما يبقى جاهز',
      },
      Cold: {
        firstComment: 'العميل مش مهتم',
        secondComment: 'هحاول معاه برضه بس من غير ما اضايقه',
      },
    };

    return commentTemplates[stageName] || { firstComment: '', secondComment: '' };
  };

  const pickerRef = useRef();

  //get all data of selected leed
  const getallactiondata = async () => {
    await dispatch(GetActionsData_action(leadid));
  };

  const [isReady, setIsReady] = useState(false);
  const [comments, setComments] = useState([]);

  useEffect(() => {
    let timeout;
    if (show) {
      setIsReady(false);
      setComments([]);

      timeout = setTimeout(async () => {
        await getallactiondata();

        setIsReady(true);
      }, 1500);
    }

    return () => clearTimeout(timeout);
  }, [show, leadid]);

  const resgetallactions = useSelector((state) => state.AllActions.Action);

  // all assigns data
  useEffect(() => {
    const getallassigns = async () => {
      await dispatch(Get_All_Lead_Assigned_Data_Action(leadid));
    };
    getallassigns();
  }, [show, leadid]);

  const resgetallassignsdata = useSelector((state) => state.AllLead_Assigned.Lead_Assigned);

  const leadAssignments = useMemo(() => {
    if (!Array.isArray(resgetallassignsdata?.data) || !leadid) return [];

    return resgetallassignsdata.data
      .filter((item) => item?.LeadId?._id === leadid)
      .sort((a, b) => new Date(a.assignDateTime) - new Date(b.assignDateTime));
  }, [resgetallassignsdata, leadid]);

  const latestAssignment =
    leadAssignments.length > 0 ? leadAssignments[leadAssignments.length - 1] : null;

  useEffect(() => {
    if (
      Array.isArray(resgetallactions?.data) &&
      Array.isArray(resgetallassignsdata?.data) &&
      leadid &&
      userlogin?.data?._id
    ) {
      const userId = userlogin.data._id;
      const leadIdStr = leadid.toString();

      const relatedActions = resgetallactions?.data?.filter(
        (action) => action?.leed?._id === leadIdStr,
      );

      const leadAssigns = resgetallassignsdata?.data
        ?.filter(
          (assign) =>
            assign?.LeadId?._id === leadIdStr && assign?.Assigned_to?.userlog?._id === userId,
        )
        .sort((a, b) => new Date(b.assignDateTime) - new Date(a.assignDateTime));

      const lastClearAssign = leadAssigns.find((assign) => assign.clearHistory === true);

      let finalFilteredComments = [];

      if (lastClearAssign) {
        const assignDateTime = new Date(lastClearAssign.assignDateTime);

        finalFilteredComments = relatedActions
          .map((action) => {
            const filtered = (action.Comments || []).filter((comment) => {
              const createdAt = new Date(comment?.firstcomment?.date);
              return createdAt > assignDateTime;
            });
            return { ...action, Comments: filtered };
          })
          .filter((action) => action.Comments.length > 0);
      } else {
        finalFilteredComments = relatedActions;
      }

      setComments(finalFilteredComments);
    }
  }, [resgetallactions, resgetallassignsdata, leadid, userlogin?.data?._id]);

  const [firstcomment, setfirstcomment] = useState('');
  const [secondcomment, setsecondcomment] = useState('');
  const [startDateTime, setStartDateTime] = useState('');

  const [loading, setloading] = useState(true);
  const [sendloading, setsendloading] = React.useState(false);

  const onfirstcommentchange = (e) => {
    setfirstcomment(e.target.value);
  };

  const onsecondcommentchange = (e) => {
    setsecondcomment(e.target.value);
  };

  //date
  //===========================================================
  const [date, setDate] = useState('');
  const [dateonly, setDateonly] = useState('');

  useEffect(() => {
    const today = new Date();
    const formattedDateandtime = today.toLocaleDateString();
    setDate(formattedDateandtime);

    const todaydayonly = new Date();
    const formattedDateonly = `${todaydayonly.getFullYear()}-${(todaydayonly.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${todaydayonly.getDate().toString().padStart(2, '0')}`;
    setDateonly(formattedDateonly);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const today = new Date();
      setDate(today.toLocaleDateString());
    }, 86400000);

    return () => clearInterval(interval);
  }, []);

  const [valuedate, setvaluedate] = useState(dayjs());

  // Calculations for commission and cashback
  useEffect(() => {
    const price = parseFloat(unitPrice);
    const ratio = parseFloat(commissionRatio);

    if (!isNaN(price) && !isNaN(ratio) && price > 0 && ratio > 0) {
      const commission = (price * ratio) / 100;
      setTotalCommission(commission.toFixed(2));
    } else {
      setTotalCommission('');
    }
  }, [unitPrice, commissionRatio]);

  // useEffect(() => {
  //   const price = parseFloat(unitPrice);
  //   const ratio = parseFloat(cashbackratio);

  //   if (!isNaN(price) && !isNaN(ratio) && price > 0 && ratio > 0) {
  //     const cashback = (totalCommission * ratio) / 100;
  //     setCashbackMoney(cashback.toFixed(2));
  //   } else {
  //     setCashbackMoney('');
  //   }
  // }, [totalCommission, cashbackratio]);

  useEffect(() => {
    const price = parseFloat(unitPrice);
    const ratio = parseFloat(cashbackratio);
    const commission = parseFloat(totalCommission);

    if (!isNaN(ratio)) {
      if (ratio === 0) {
        // لو ال ratio = 0، الـ cashback بيكون 0
        setCashbackMoney('0');
      } else if (!isNaN(commission) && commission > 0 && ratio > 0) {
        // لو في ratio موجب، احسب بشكل طبيعي
        const cashback = (commission * ratio) / 100;
        setCashbackMoney(cashback.toFixed(2));
      } else {
        setCashbackMoney('');
      }
    } else {
      setCashbackMoney('');
    }
  }, [cashbackratio, totalCommission, unitPrice]);

  // Handlers for form fields
  const handlePriceChange = (e) => {
    const value = e.target.value;
    setUnitPrice(value);
    const price = parseFloat(value);
    setIsPriceValid(!isNaN(price) && price > 0);
  };

  const handleunitnumber = (e) => {
    setunitnumber(e.target.value);
    setisunitnumberValid(e.target.value.trim() !== '');
  };

  const handlecommissionratioChange = (e) => {
    const value = e.target.value;
    setcommissionratio(value);
    const commissionratio = parseFloat(value);
    setIscommissionratioValid(!isNaN(commissionratio) && commissionratio > 0);
  };

  const handlecashbackratiochange = (e) => {
    const value = e.target.value;
    setcashbackratio(value);
    const cashbackratio = parseFloat(value);
    setiscashbackratiovalid(!isNaN(cashbackratio) && cashbackratio >= 0);
  };

  const handleEoiAmountChange = (e) => {
    const value = e.target.value;
    setEoiAmount(value);
    const amount = parseFloat(value);
    setIsEoiAmountValid(!isNaN(amount) && amount > 0);
  };

  const handleReservationAmountChange = (e) => {
    const value = e.target.value;
    setReservationAmount(value);
    const amount = parseFloat(value);
    setIsReservationAmountValid(!isNaN(amount) && amount > 0);
  };

  // Function to reset stage form
  const resetStageForm = () => {
    setUnitPrice('');
    setunitnumber('');
    setcommissionratio('');
    setcashbackratio('');
    setEoiAmount('');
    setReservationAmount('');
    setIsPriceValid(false);
    setisunitnumberValid(false);
    setIscommissionratioValid(false);
    setiscashbackratiovalid(false);
    setIsEoiAmountValid(false);
    setIsReservationAmountValid(false);
    setStageType(null);
    setSelectedStage(null);
    setShowDateTimePicker(false);
    setvaluedate(null);
    setAnswerNoAnswerSwitch(false);
  };

  const handleDateTimeChange = (newValue) => {
    if (newValue) {
      setvaluedate(newValue);

      // Add date and time automatically to second comment
      const formattedDateTime = moment(newValue.toDate()).format('MMMM Do YYYY, h:mm A');
      const currentSecondComment = secondcomment || '';

      // Remove any existing date to avoid duplicates
      const commentWithoutDate = currentSecondComment
        .replace(/ - Follow up on .*$/, '')
        .replace(/ - Scheduled for .*$/, '')
        .replace(/ - Next action on .*$/, '');

      const newComment = commentWithoutDate
        ? `${commentWithoutDate} - Follow up on ${formattedDateTime}`
        : `Follow up on ${formattedDateTime}`;

      setsecondcomment(newComment);
    }
  };

  // Confetti function for Done Deal
  const DoneDealFun = () => {
    const jsConfetti = new JSConfetti();
    jsConfetti.addConfetti({
      confettiColors: ['#ff0a54', '#ff477e', '#ff7096', '#ff85a1', '#fbb1bd', '#f9bec7'],
    });
  };

  //on submit data
  const onsubmitdata = async (e) => {
    e.preventDefault();

    // ✅ Check required fields
    if (!firstcomment.trim()) {
      return Notify('error', 'Please enter first comment', 'error');
    }
    if (!secondcomment.trim()) {
      return Notify('error', 'Please enter second comment', 'error');
    }

    // ✅ If stage needs DateTimePicker, check date
    if (showDateTimePicker && !valuedate) {
      return Notify('error', 'Please select date & time', 'error');
    }

    // ✅ For other stages, use current time
    if (!showDateTimePicker && !valuedate) {
      setvaluedate(dayjs()); // Set to current time
    }

    // ✅ If Add Action is enabled, validate stage requirements
    if (addActionEnabled && selectedStageId) {
      // التحقق من صحة المبالغ في EOI و Reservation
      if (selectedStageName === 'EOI' && (!isEoiAmountValid || eoiAmount === '')) {
        return Notify('error', 'Please enter a valid EOI amount', 'error');
      }

      if (
        selectedStageName === 'Reservation' &&
        (!isReservationAmountValid || reservationAmount === '')
      ) {
        return Notify('error', 'Please enter a valid Reservation amount', 'error');
      }

      if (selectedStageName === 'Done Deal') {
        const price = parseFloat(unitPrice);
        if (isNaN(price) || price <= 0) {
          return Notify('error', 'Please enter a valid unit price (greater than zero)', 'error');
        }
        if (!unitnumber.trim()) {
          return Notify('error', 'Please enter unit number', 'error');
        }
        if (!commissionRatio || parseFloat(commissionRatio) <= 0) {
          return Notify('error', 'Please enter a valid commission ratio', 'error');
        }
        if (!cashbackratio || cashbackratio < 0) {
          return Notify('error', 'Please enter a valid cashback ratio', 'error');
        }
      }
    }

    setloading(true);
    setsendloading(true);

    try {
      // Determine which stage to use
      const stageIdToUse = addActionEnabled && selectedStage ? selectedStage._id : user?.stage?._id;

      console.log('Add Action Enabled:', addActionEnabled);
      console.log('Selected Stage:', selectedStage);
      console.log('Stage ID to Use:', stageIdToUse);
      console.log('Current User Stage:', user?.stage?._id);

      const finalStageDate = valuedate ? valuedate : dayjs();
      // إذا كان الـ Add Action مفعل، قم بتحديث الـ stage أولاً
      if (addActionEnabled) {
        console.log('🔄 Updating stage to:', selectedStageName);

        const updateData = {
          stage: selectedStageId,
          stagedateupdated: finalStageDate,
          last_stage_date_updated: dateonly,
          ...(selectedStageName === 'Done Deal' && {
            unit_price: parseFloat(unitPrice),
            review: false,
            unitnumber: unitnumber,
            commissionratio: parseFloat(commissionRatio),
            commissionmoney: totalCommission,
            cashbackratio: parseFloat(cashbackratio),
            cashbackmoney: cashbackMoney,
          }),
          ...(selectedStageName === 'EOI' && {
            Eoi: parseFloat(eoiAmount),
          }),
          ...(selectedStageName === 'Reservation' && {
            Reservation: parseFloat(reservationAmount),
          }),
        };

        console.log('📤 Update Data:', updateData);

        // انتظر اكتمال تحديث الـ stage أولاً
        const updateStageResult = await dispatch(UpdateStageToLeed(user._id, updateData));

        console.log('✅ Stage Update Result:', updateStageResult);

        // if (updateStageResult ) {
        // إضافة سجل في Lead Stages
        const leadStageData = {
          LeadId: user._id,
          date: dateonly,
          stage: selectedStageId,
          sales: userlogin.data._id,
          dateselectedforstage: finalStageDate,
          ...(selectedStageName === 'Done Deal' && {
            unitPrice: parseFloat(unitPrice),
          }),
        };

        console.log('📝 Lead Stage Data:', leadStageData);

        await dispatch(Insert_Lead_Stages_Data_Action(leadStageData));

        // إذا كانت Done Deal، شغل الكونفيتي
        if (selectedStageName === 'Done Deal') {
          DoneDealFun();
        }
        // }

        // else {
        //   throw new Error("❌ Failed to update stage");
        // }
      }

      // إضافة الكومنت
      console.log('💬 Adding comment with stage:', stageIdToUse);

      const actionResponse = await dispatch(
        InsertNewAction_action({
          sales: userlogin.data._id,
          text1: firstcomment,
          text2: secondcomment,
          date: finalStageDate,
          leed: user._id,
          username: userloginrealy.data._id,
          commentbysales: userlogin.data.name,
          stage: user?.stage?._id,
        }),
      );

      console.log('📨 Action Response:', actionResponse);

      // if (!actionResponse || actionResponse.error) {
      //   throw new Error("❌ Failed to insert new action");
      // }

      Notify('success', 'Data sent successfully!', 'success');

      // Reset form
      // setfirstcomment('');
      // setsecondcomment('');
      // setvaluedate(null);
      // setShowDateTimePicker(false);
      // setAddActionEnabled(false);
      // resetStageForm();

      // Refresh data
      await getallactiondata();
    } catch (error) {
      console.error('❌ Error submitting data:', error);
      Notify('error', 'Error sending data, please try again.', 'error');
    } finally {
      setloading(false);
      setsendloading(false);
    }
  };

  const resaddcomment = useSelector((state) => state.AllActions.AddAction);

  useEffect(() => {
    if (loading === false) {
      if (resaddcomment && resaddcomment.data.status === 'success') {
        pushno();

        Notify('success', 'Comments added successfully', 'success');
        setfirstcomment('');
        setsecondcomment('');
        getallactiondata();
      } else {
        Notify('error', 'Failed to add comments', 'error');
        return;
      }
    }
  }, [loading]);

  const pushno = async () => {
    try {
      const response = await axios.post(
        `${db_url}api/v1/Notification/send-fcm`,
        {
          fcmToken: user?.sales?.userlog?.fcmToken,
          title: '💬 New Comment (FCM)',
          body: `New Comment From User: ${userlogin?.data?.name} on Lead: ${user?.name}`,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
    } catch (error) {
      console.error('❌ Failed to send FCM notification:', error.response?.data || error.message);
    }
  };

  //==================================================================
  useEffect(() => {
    if (JSON.parse(localStorage.getItem('user')) != null) {
      setuserlogin(JSON.parse(localStorage.getItem('user')));
    }
  }, []);

  // Handle stage change
  // أضف هذا الـ state مع الـ states الأخرى
  const [selectedStageId, setSelectedStageId] = useState(null);
  const [selectedStageName, setSelectedStageName] = useState(null);

  // ثم في handleStageChange:
  const handleStageChange = (event, newValue) => {
    if (newValue) {
      setSelectedStage(newValue);
      const stageName = newValue.name;
      const stageId = newValue._id;

      // حفظ الـ ID و Name في states
      setSelectedStageId(stageId);
      setSelectedStageName(stageName);

      console.log('🔍 Selected Stage:', newValue);
      console.log('📝 Stage Name:', stageName);
      console.log('🆔 Stage ID:', stageId);

      // Reset form when changing stage
      resetStageForm();

      // Check if stage needs DateTimePicker
      if (
        stagesWithDateTime.includes(stageName) ||
        stageName === 'Answer' ||
        stageName === 'No Answer'
      ) {
        setShowDateTimePicker(true);
      } else {
        setShowDateTimePicker(false);
        setvaluedate(null);
      }

      // Get stage type
      dispatch(GetOne_stagetogettype_Data(stageId));

      // Generate automatic comments
      const autoComments = generateAutoComments(stageName);
      setfirstcomment(autoComments.firstComment);
      setsecondcomment(autoComments.secondComment);

      // حفظ في localStorage إذا كنت تحتاجه
      localStorage.setItem('selectedStageId', stageId);
      localStorage.setItem('selectedStageName', stageName);
    } else {
      // If no stage selected, reset everything
      setSelectedStage(null);
      setSelectedStageId(null); // إعادة تعيين الـ ID
      setSelectedStageName(null); // إعادة تعيين الـ Name
      setStageType(null);
      setShowDateTimePicker(false);
      resetStageForm();

      // إزالة من localStorage
      localStorage.removeItem('selectedStageId');
      localStorage.removeItem('selectedStageName');
    }
  };

  // Get stage type from useSelector - نفس الكود اللي في UpdateStage
  const resgetonestagetype = useSelector((state) => state.Allstages.getstagetogetype);

  useEffect(() => {
    if (resgetonestagetype) {
      console.log('🔍 FULL API RESPONSE:', resgetonestagetype);
      console.log('📊 Response Data:', resgetonestagetype.data);
      console.log('🎯 Stage Type Object:', resgetonestagetype.data?.stagetype);
      console.log('🏷️ Stage Type Name:', resgetonestagetype.data?.stagetype?.name);

      if (resgetonestagetype.data) {
        setStageType(resgetonestagetype.data);
      } else {
        setStageType(null);
      }
    } else {
      setStageType(null);
    }
  }, [resgetonestagetype]);
  let onetype_of_stage = [];
  if (resgetonestagetype && resgetonestagetype.data) {
    onetype_of_stage = resgetonestagetype.data;
  } else {
    onetype_of_stage = [];
  }

  //=================================================================

  //leed preview dialog
  const [open, setOpen] = React.useState(false);

  const handleClickOpenleed = () => {
    setOpen(true);
  };

  const handleCloseleed = () => {
    setOpen(false);
  };

  //full screen dialog
  const [openfullscreen, setOpenfullscreen] = React.useState(false);

  const handleClickOpen = () => {
    setOpenfullscreen(true);
  };

  const handleClosefullscreen = () => {
    setOpenfullscreen(false);
  };

  const divRef = useRef(null);
  const cursorPosition = useRef(0);

  const saveCursorPosition = () => {
    const selection = window.getSelection();
    if (!selection.rangeCount) return;
    const range = selection.getRangeAt(0);
    cursorPosition.current = range.startOffset;
  };

  const restoreCursorPosition = () => {
    const selection = window.getSelection();
    const range = document.createRange();
    if (divRef.current.childNodes.length > 0) {
      range.setStart(divRef.current.childNodes[0], cursorPosition.current);
      range.setEnd(divRef.current.childNodes[0], cursorPosition.current);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  };

  const onPopupChange = (e) => {
    saveCursorPosition();
    setsecondcomment(e.target.innerText);
    setTimeout(restoreCursorPosition, 0);
  };

  const onPopupfirstcommentchangeChange = (e) => {
    setfirstcomment(e.target.innerText);
  };

  //==========================================================================

  // checking number have whats app or not

  // check for confirm recieve lead from sales but this role on all user except admin and marketer
  const isClickable =
    user.assign !== true ||
    user?.sales?.userlog === userlogin?.data?._id ||
    userlogin?.data?.role === 'Admin' ||
    userlogin?.data?.role === 'Marketer';

  const [allstagesshow, setallstagesshow] = useState([]);
  const getallstages = async () => {
    await dispatch(GetAll_stage_Data());
  };

  useEffect(() => {
    getallstages();
  }, []);

  const All_stages = useSelector((state) => state.Allstages.stage);

  useEffect(() => {
    if (All_stages && All_stages?.data) {
      setallstagesshow(All_stages.data);
    }
  }, [All_stages]);

  useEffect(() => {
    if (addActionEnabled && user?.stage && !selectedStage) {
      // إذا كان الـ switch مفعل ولم يكن هناك stage محدد، تعيين الـ current stage
      setSelectedStage(user.stage);
      setSelectedStageId(user.stage._id);
      setSelectedStageName(user.stage.name);

      // التحقق إذا كان الـ stage الحالي يحتاج DateTimePicker
      if (stagesWithDateTime.includes(user.stage.name)) {
        setShowDateTimePicker(true);
      }

      // الحصول على نوع الـ stage الحالي
      dispatch(GetOne_stagetogettype_Data(user.stage._id));
    }
  }, [user, addActionEnabled, selectedStage]);
  return (
    <div>
      <Offcanvas
        placement="end"
        show={show}
        onHide={handleClose}
        style={{ width: '670px', background: '#fff', zIndex: '', color: '#0F7687' }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title style={{ color: 'white', textAlign: 'center', width: '100%' }}>
            <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#0F7687' }}>Actions</div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div style={{ marginTop: '5px' }}>
            <div className="mx-2 iconsofaction" style={{ color: '#666' }}>
              {' '}
              USER Name :{userlogin && userlogin?.data ? userlogin?.data?.name : null}
            </div>
            <hr />

            {/* //show leed data  */}
            <Dialog
              open={open}
              TransitionComponent={Transition}
              keepMounted
              onClose={handleCloseleed}
              aria-describedby="alert-dialog-slide-description"
              maxWidth="sm"
              fullWidth
            >
              <DialogTitle sx={{ color: '#333', fontWeight: 'bold' }}>Lead Preview</DialogTitle>

              <DialogContent dividers sx={{ backgroundColor: '#f9f9f9' }}>
                {/* Contact Info Section */}
                <section
                  style={{ paddingBottom: '10px', borderBottom: '1px solid #ccc', color: '#666' }}
                >
                  <h6 style={{ color: '#333', fontWeight: '600' }}>Contact Information</h6>
                  <div style={{ lineHeight: '1.8' }}>
                    <div>
                      <ManIcon /> <strong>Lead Name:</strong> {user?.name}
                    </div>
                    <div>
                      <AlternateEmailIcon /> <strong>Email:</strong> {user?.email || 'Not Exist'}
                    </div>
                    <div>
                      <PhoneIphoneIcon /> <strong>Phone 1:</strong> {user?.phone || 'Not Exist'}
                    </div>
                    <div>
                      <PhoneIphoneIcon /> <strong>Phone 2:</strong>{' '}
                      {user?.phonenumber2 || 'Not Exist'}
                    </div>
                    <div>
                      <WhatsAppIcon /> <strong>WhatsApp:</strong>{' '}
                      {user?.whatsappnumber || 'Not Exist'}
                    </div>
                  </div>
                </section>

                {/* General Info Section */}
                <section style={{ paddingTop: '10px' }}>
                  <h6 style={{ color: '#333', fontWeight: '600' }}>General Information</h6>
                  <div style={{ lineHeight: '1.8', color: '#666' }}>
                    <div>
                      <WbIncandescentIcon /> <strong>Job Description:</strong>{' '}
                      {user?.jobdescription || 'Not Exist'}
                    </div>
                    <div>
                      <HistoryIcon /> <strong>Stage:</strong> {user?.stage?.name}
                    </div>
                    <div>
                      <HomeWorkIcon /> <strong>Project:</strong> {user?.project?.name}
                    </div>
                    <div>
                      <HomeWorkIcon /> <strong>Developer:</strong> {user?.project?.developer?.name}
                    </div>
                    <div>
                      <CalendarMonthIcon /> <strong>Creation Date:</strong>{' '}
                      {moment(user?.createdAt || user?.updatedAt).format('DD MMMM YYYY')}
                    </div>
                    <div>
                      <CalendarMonthIcon /> <strong>Creation Time:</strong>{' '}
                      {moment(user?.createdAt || user?.updatedAt).format('h : mm A')}
                    </div>
                    <div>
                      <ShareIcon /> <strong>Channel:</strong> {user?.chanel?.name}
                    </div>
                    <div>
                      <FolderSharedIcon /> <strong>Salesman:</strong> {user?.sales?.name}
                    </div>
                    <div>
                      <TextsmsIcon /> <strong>Communication Way:</strong>{' '}
                      {user?.communicationway?.name}
                    </div>
                    <div>
                      <SatelliteAltIcon /> <strong>Campaign:</strong> {user?.campaign?.CampainName}
                    </div>
                    <div>
                      <HistoryIcon /> <strong>Status:</strong> {user?.leedtype}
                    </div>
                  </div>
                </section>

                {/* Notes Section */}
                {user?.notes && (
                  <>
                    <hr />
                    <section>
                      <h6 style={{ color: '#666', fontWeight: '600' }}>Notes :</h6>
                      <div style={{ lineHeight: '1.8' }}>{user?.notes}</div>
                    </section>
                  </>
                )}







                {/* Admin Only Section */}
                {userlogin?.data?.role === 'Admin' && user?.stage?.name === 'Done Deal' ? (
                  <>
                    <hr />
                    <section>
                      <h6 style={{ color: '#333', fontWeight: '600' }}>
                        Admin Details (Done Deal)
                      </h6>
                      <div style={{ lineHeight: '1.8', color: '#0F7687' }}>
                        <div>
                          <NotesIcon /> <strong>Unit Price:</strong> {user?.unit_price}
                        </div>
                        <div>
                          <NotesIcon /> <strong>Unit Number:</strong> {user?.unitnumber}
                        </div>
                        <div>
                          <NotesIcon /> <strong>Commission Rate:</strong> {user?.commissionratio}%
                        </div>
                        <div>
                          <NotesIcon /> <strong>Commission Money:</strong> {user?.commissionmoney}
                        </div>
                        <div>
                          <NotesIcon /> <strong>Cashback Rate:</strong> {user?.cashbackratio}%
                        </div>
                        <div>
                          <NotesIcon /> <strong>Cashback Money:</strong> {user?.cashbackmoney}
                        </div>
                      </div>
                    </section>
                  </>
                ) : null}
              </DialogContent>

              <DialogActions>
                <Button
                  onClick={handleCloseleed}
                  variant="contained"
                  sx={{ backgroundColor: '#102dff', color: 'white' }}
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>

            {/* //dialog full screen for all comments to selected leed */}
            <Dialog
              fullScreen
              open={openfullscreen}
              onClose={handleClosefullscreen}
              TransitionComponent={Transition}
              sx={{
                '& .MuiDialog-container': {
                  zIndex: 20000,
                },
              }}
              className="commentdialog"
            >
              <AppBar
                sx={{
                  position: 'fixed',
                  top: 0,
                  background: '#102dff',
                  height: '64px',
                }}
                className="commentdialog"
              >
                <Toolbar>
                  <IconButton
                    edge="start"
                    color="inherit"
                    onClick={handleClosefullscreen}
                    aria-label="close"
                  >
                    <CloseIcon />
                  </IconButton>
                  <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                    Comments ({comments ? comments.length : 0})
                  </Typography>
                  <Button autoFocus color="inherit" onClick={handleClosefullscreen}>
                    HOMEWALKERS
                  </Button>
                </Toolbar>
              </AppBar>

              <div
                style={{
                  paddingTop: '64px',
                  height: 'calc(100vh - 64px)',
                  overflow: 'auto',
                }}
              >
                <List>
                  <div
                    style={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      flexWrap: 'wrap',
                    }}
                  >
                    {comments
                      ?.filter((item) => item.Comments && item.Comments.length > 0)
                      .map((item, index) => (
                        <AllCommentsCommponentMainShow key={index} comments={item} user={user} />
                      ))}
                  </div>
                  <Divider />
                </List>
              </div>
            </Dialog>

            <div className="d-flex justify-content-between w-100">
              <div style={{ color: '#666' }}>Lead Info</div>

              <div className="d-flex">
                <Tooltip title="Lead Preview" arrow>
                  <div
                    className="mx-2 iconsofaction"
                    style={{ color: '#666' }}
                    onClick={handleClickOpenleed}
                  >
                    <VisibilityIcon />
                  </div>
                </Tooltip>

                {userlogin && userlogin.data ? (
                  userlogin.data.role === 'Sales' || 'Team Leader' ? (
                    <div></div>
                  ) : (
                    <Tooltip title="Edit Lead" arrow>
                      <Link to={`/updateclient/${user._id}`}>
                        <div className="mx-2 iconsofaction" style={{ color: '#666' }}>
                          <EditIcon />
                        </div>
                      </Link>
                    </Tooltip>
                  )
                ) : null}

                <Tooltip title={`All Comments For ${user.name}`} arrow>
                  <div
                    className="mx-2 iconsofaction"
                    style={{ color: '#666' }}
                    onClick={handleClickOpen}
                  >
                    <TextsmsIcon />
                  </div>
                </Tooltip>

                {user?.sales?.userlog?._id === userlogin?.data?._id ? (
                  <Tooltip title={`Stage arrow`}>
                    <Link
                      to={`/updatestage/${user._id}/${user.sales ? user.sales._id : null}`}
                      style={{ textDecoration: 'none' }}
                    >
                      <div className="mx-2 iconsofaction" style={{ color: '#666' }}>
                        <AddCircleIcon />
                      </div>
                    </Link>
                  </Tooltip>
                ) : null}

                <Tooltip title={`Lead Assigned`}>
                  <Link to={`/LeadAssigned/${user._id}`} style={{ textDecoration: 'none' }}>
                    <div className="mx-2 iconsofaction" style={{ color: '#666' }}>
                      <InfoIcon />
                    </div>
                  </Link>
                </Tooltip>

                <Tooltip title={`Leads Stages`}>
                  <Link to={`/LeadStages/${user._id}`} style={{ textDecoration: 'none' }}>
                    <div className="mx-2 iconsofaction" style={{ color: '#666' }}>
                      <CachedIcon />
                    </div>
                  </Link>
                </Tooltip>
              </div>
            </div>

            <div className="container my-3">
              <div className="row">
                {/* Row 1: Lead Name and Sales Name */}
                <div className="col-md-6 mb-2">
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      fontSize: '15px',
                      color: '#666',
                    }}
                  >
                    <i className="bi bi-person" style={{ marginRight: '5px' }}></i>
                    <strong style={{ color: '#666' }}>
                      <AccessibilityNewIcon />
                      Lead Name:
                    </strong>
                    &nbsp; {user?.name}
                  </div>
                </div>
                <div className="col-md-6 mb-2">
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      fontSize: '15px',
                      color: '#666',
                    }}
                  >
                    <i className="bi bi-person" style={{ marginRight: '5px' }}></i>
                    <strong>
                      <PermContactCalendarIcon
                        style={{ fontFamily: 'Montserrat', color: '#666' }}
                      />
                      Sales Name:
                    </strong>
                    &nbsp; {user?.sales?.name}
                  </div>
                </div>
                {/* Row 2: Phone 1 and Phone 2 */}
                <div className="col-md-6 mb-2">
                  <div
                    className="iconsofaction"
                    style={{ color: '#666', cursor: 'pointer', fontSize: '15px' }}
                    onClick={() => window.open(`https://wa.me/${user?.phone}`, '_blank')}
                  >
                    <PhoneInTalkIcon style={{ marginRight: '5px' }} />
                    <strong>Phone 1:</strong> {user?.phone}
                  </div>
                </div>
                <div className="col-md-6 mb-2">
                  <div
                    className="iconsofaction"
                    style={{ color: '#666', cursor: 'pointer', fontSize: '15px' }}
                    onClick={() => window.open(`https://wa.me/${user?.phonenumber2}`, '_blank')}
                  >
                    <PhoneInTalkIcon style={{ marginRight: '5px' }} />
                    <strong>Phone 2:</strong> {user?.phonenumber2 || 'Not Exist'}
                  </div>
                </div>

                {/* Row 3: WhatsApp */}
                <div className="col-md-6 mb-2">
                  <div
                    className="iconsofaction"
                    style={{ color: '#666', cursor: 'pointer', fontSize: '15px' }}
                    onClick={() =>
                      window.open(
                        `https://wa.me/${user?.whatsappnumber ? user?.whatsappnumber : user?.phone}`,
                        '_blank',
                      )
                    }
                  >
                    <WhatsAppIcon style={{ marginRight: '5px' }} />
                    <strong>WhatsApp:</strong>{' '}
                    {user?.whatsappnumber ? user?.whatsappnumber : user?.phone || 'Not Exist'}
                  </div>
                </div>
              </div>
            </div>

            <hr style={{ color: '#666' }} />

            <div className="d-flex justify-content-between w-100 mt-2">
              {/* Add Action Switch */}
              <FormControlLabel
                control={
                  <Switch
                    checked={addActionEnabled}
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      setAddActionEnabled(isChecked);

                      if (isChecked) {
                        // عندما يتم تفعيل الـ switch، تعيين الـ current stage تلقائياً
                        if (user?.stage) {
                          setSelectedStage(user.stage);
                          setSelectedStageId(user.stage._id);
                          setSelectedStageName(user.stage.name);

                          // التحقق إذا كان الـ stage الحالي يحتاج DateTimePicker
                          if (stagesWithDateTime.includes(user.stage.name)) {
                            setShowDateTimePicker(true);
                          } else {
                            setShowDateTimePicker(false);
                            setvaluedate(null);
                          }

                          // الحصول على نوع الـ stage الحالي
                          dispatch(GetOne_stagetogettype_Data(user.stage._id));

                          // توليد تعليقات تلقائية للـ stage الحالي
                          const autoComments = generateAutoComments(user.stage.name);
                          setfirstcomment(autoComments.firstComment);
                          setsecondcomment(autoComments.secondComment);
                        }
                      } else {
                        // إذا تم إيقاف التشغيل، إعادة تعيين كل شيء
                        resetStageForm();
                      }
                    }}
                    color="primary"
                  />
                }
                label="Add Action"
                style={{ color: '#666', marginRight: '10px' }}
              />

              {/* Answer/No Answer Switch */}
              <FormControlLabel
                control={
                  <Switch
                    checked={answerNoAnswerSwitch}
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      setAnswerNoAnswerSwitch(isChecked);

                      if (isChecked) {
                        // إذا تم تفعيل الـ Switch - No Answer
                        setfirstcomment('No Answer');
                        setsecondcomment('العميل لم يرد وسوف اتصل به مره اخري ');
                      } else {
                        // إذا تم إلغاء الـ Switch - Answer
                        setfirstcomment('Answer');
                        setsecondcomment('Document conversation details and plan next steps');
                      }
                    }}
                    color="primary"
                  />
                }
                label={answerNoAnswerSwitch ? 'No Answer' : 'Answer'}
                style={{ color: '#666', marginRight: '10px' }}
              />
            </div>

            {/* Current Stage - always visible */}
            <div className="w-100 d-flex justify-content-center mt-2">
              <div>Current Stage: {user?.stage?.name}</div>
            </div>

            {/* Add Action Section - only visible when switch is ON */}
            {addActionEnabled && (
              <>
                <hr style={{ color: '#666' }} />
                <div className="w-100 d-flex justify-content-center">
                  <div style={{ color: '#0F7687', fontWeight: 'bold' }}>Change Stage To:</div>
                </div>
                <div className="d-flex w-100">
                  {allstagesshow && (
                    <Autocomplete
                      disablePortal
                      options={allstagesshow}
                      getOptionLabel={(option) => option.name || ''}
                      value={selectedStage}
                      onChange={(event, newValue) => {
                        setSelectedStage(newValue);

                        if (newValue) {
                          // إضافة المنطق الإضافي هنا
                          const stageName = newValue.name;
                          const stageId = newValue._id;
                          setSelectedStageId(stageId);
                          setSelectedStageName(stageName);

                          // إعادة تعيين النموذج
                          // resetStageForm();

                          // التحقق إذا كان Stage يحتاج DateTimePicker
                          if (stagesWithDateTime.includes(stageName)) {
                            setShowDateTimePicker(true);
                          } else {
                            setShowDateTimePicker(false);
                            setvaluedate(null);
                          }

                          // الحصول على نوع الـ Stage
                          dispatch(GetOne_stagetogettype_Data(stageId));

                          // توليد تعليقات تلقائية
                          const autoComments = generateAutoComments(stageName);
                          setfirstcomment(autoComments.firstComment);
                          setsecondcomment(autoComments.secondComment);
                        } else {
                          // إذا لم يتم اختيار شيء
                          setSelectedStage(null);
                          setSelectedStageId(null);
                          setSelectedStageName(null);
                          setStageType(null);
                          setShowDateTimePicker(false);
                          resetStageForm();
                        }
                      }}
                      isOptionEqualToValue={(option, value) => option?._id === value?._id}
                      sx={{ width: '100%', mt: 1 }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Choose New Stage"
                          variant="outlined"
                          size="small"
                        />
                      )}
                    />
                  )}
                </div>

                {/* DateTimePicker appears under stages only for specific stages - INCLUDING Answer and No Answer */}
                {showDateTimePicker && (
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Box sx={{ width: '100%', mt: 2 }}>
                      <DesktopDateTimePicker
                        label="Select Next Action Date & Time"
                        value={valuedate}
                        onChange={handleDateTimeChange}
                        ampm={true}
                        slotProps={{
                          popper: {
                            modifiers: [
                              {
                                name: 'zIndex',
                                enabled: true,
                                phase: 'write',
                                fn: ({ state }) => {
                                  state.elements.popper.style.zIndex = '46000';
                                },
                              },
                            ],
                          },
                          textField: {
                            fullWidth: true,
                            sx: { width: '100%', color: '#666' },
                          },
                        }}
                      />
                    </Box>
                  </LocalizationProvider>
                )}

                {/* EOI Amount Field - بنفس منطق UpdateStage */}
                {selectedStage &&
                  stageType &&
                  stageType.stagetype &&
                  stageType.stagetype.name === 'EOI' && (
                    <div className="mt-3">
                      <FormControl fullWidth margin="normal">
                        <TextField
                          id="eoi-amount"
                          label="Amount (AED)"
                          type="number"
                          value={eoiAmount}
                          onChange={handleEoiAmountChange}
                          variant="outlined"
                          required
                          error={!isEoiAmountValid && eoiAmount !== ''}
                          helperText={
                            !isEoiAmountValid && eoiAmount !== ''
                              ? 'Please enter a valid amount'
                              : eoiAmount === ''
                                ? 'Please enter the amount in AED'
                                : ''
                          }
                          inputProps={{
                            min: 0.01,
                            step: 0.01,
                          }}
                        />
                      </FormControl>
                    </div>
                  )}

                {/* Reservation Amount Field - بنفس منطق UpdateStage */}
                {selectedStage &&
                  stageType &&
                  stageType.stagetype &&
                  stageType.stagetype.name === 'Reservation' && (
                    <div className="mt-3">
                      <FormControl fullWidth margin="normal">
                        <TextField
                          id="reservation-amount"
                          label="Amount (AED)"
                          type="number"
                          value={reservationAmount}
                          onChange={handleReservationAmountChange}
                          variant="outlined"
                          required
                          error={!isReservationAmountValid && reservationAmount !== ''}
                          helperText={
                            !isReservationAmountValid && reservationAmount !== ''
                              ? 'Please enter a valid amount'
                              : reservationAmount === ''
                                ? 'Please enter the amount in AED'
                                : ''
                          }
                          inputProps={{
                            min: 0.01,
                            step: 0.01,
                          }}
                        />
                      </FormControl>
                    </div>
                  )}

                {/* Done Deal Fields - بنفس منطق UpdateStage */}
                {/* Done Deal Fields - استخدام selectedStage.name مباشرة */}
              </>
            )}

            {onetype_of_stage &&
            onetype_of_stage.stagetype &&
            onetype_of_stage.stagetype.name === 'Done Deal' ? (
              <div>
                <div
                  style={{
                    backgroundColor: '#f0f8ff',
                    padding: '15px',
                    borderRadius: '8px',
                    marginBottom: '15px',
                  }}
                >
                  <h5 style={{ color: '#0F7687', marginBottom: '15px' }}>
                    ✅ Done Deal Information
                  </h5>

                  {/* الحقول تبقى هنا */}
                  <div className="mt-3">
                    <FormControl fullWidth margin="normal">
                      <TextField
                        id="unit-price"
                        label="Unit Price (AED)"
                        type="number"
                        value={unitPrice}
                        onChange={handlePriceChange}
                        variant="outlined"
                        required
                        error={!isPriceValid && unitPrice !== ''}
                        helperText={
                          !isPriceValid && unitPrice !== ''
                            ? 'Please enter a valid unit price'
                            : 'Enter the total unit price'
                        }
                        inputProps={{
                          min: 0.01,
                          step: 0.01,
                        }}
                      />
                    </FormControl>
                  </div>

                  <div className="mt-3">
                    <FormControl fullWidth margin="normal">
                      <TextField
                        id="unitnumber"
                        label="Unit Number"
                        type="text"
                        value={unitnumber}
                        onChange={handleunitnumber}
                        variant="outlined"
                        required
                        error={!isunitnumberValid && unitnumber !== ''}
                        helperText={
                          !isunitnumberValid && unitnumber !== ''
                            ? 'Please enter unit number'
                            : 'Enter the unit number/identifier'
                        }
                      />
                    </FormControl>
                  </div>

                  <div className="mt-3">
                    <FormControl fullWidth margin="normal">
                      <TextField
                        id="commission-Ratio"
                        label="Commission Ratio %"
                        type="number"
                        value={commissionRatio}
                        onChange={handlecommissionratioChange}
                        variant="outlined"
                        required
                        error={!commissionratioValid && commissionRatio !== ''}
                        helperText={
                          !commissionratioValid && commissionRatio !== ''
                            ? 'Please enter valid commission ratio'
                            : 'Enter commission percentage'
                        }
                        inputProps={{
                          min: 0.01,
                          step: 0.01,
                          max: 100,
                        }}
                      />
                    </FormControl>
                  </div>

                  <TextField
                    label="Total Commission (AED)"
                    value={totalCommission}
                    disabled
                    fullWidth
                    margin="normal"
                    helperText="Calculated automatically"
                  />

                  <div className="mt-3">
                    <FormControl fullWidth margin="normal">
                      <TextField
                        id="cashback-ratio"
                        label="Cashback Ratio %"
                        type="number"
                        value={cashbackratio}
                        onChange={handlecashbackratiochange}
                        variant="outlined"
                        required
                        error={!cahbackratiovalid && cashbackratio !== ''}
                        helperText={
                          !cahbackratiovalid && cashbackratio !== ''
                            ? 'Please enter a valid cashback ratio (0 or higher)'
                            : 'Enter cashback percentage (0 for no cashback)'
                        }
                        inputProps={{
                          min: 0.0,
                          step: 0.01,
                          max: 100,
                        }}
                      />
                    </FormControl>
                  </div>

                  <TextField
                    label="Cashback Amount (AED)"
                    value={cashbackMoney}
                    disabled
                    fullWidth
                    margin="normal"
                    helperText="Calculated automatically"
                  />
                </div>
              </div>
            ) : null}

            {/* EOI Amount Field - استخدام selectedStage.name مباشرة */}
            {onetype_of_stage &&
            onetype_of_stage.stagetype &&
            onetype_of_stage.stagetype.name === 'EOI' ? (
              <div className="mt-3">
                <FormControl fullWidth margin="normal">
                  <TextField
                    id="eoi-amount"
                    label="Amount (AED)"
                    type="number"
                    value={eoiAmount}
                    onChange={handleEoiAmountChange}
                    variant="outlined"
                    required
                    error={!isEoiAmountValid && eoiAmount !== ''}
                    helperText={
                      !isEoiAmountValid && eoiAmount !== ''
                        ? 'Please enter a valid amount'
                        : eoiAmount === ''
                          ? 'Please enter the amount in AED'
                          : ''
                    }
                    inputProps={{
                      min: 0.01,
                      step: 0.01,
                    }}
                  />
                </FormControl>
              </div>
            ) : null}

            {/* Reservation Amount Field - استخدام selectedStage.name مباشرة */}
            {onetype_of_stage &&
            onetype_of_stage.stagetype &&
            onetype_of_stage.stagetype.name === 'Reservation' ? (
              <div className="mt-3">
                <FormControl fullWidth margin="normal">
                  <TextField
                    id="reservation-amount"
                    label="Amount (AED)"
                    type="number"
                    value={reservationAmount}
                    onChange={handleReservationAmountChange}
                    variant="outlined"
                    required
                    error={!isReservationAmountValid && reservationAmount !== ''}
                    helperText={
                      !isReservationAmountValid && reservationAmount !== ''
                        ? 'Please enter a valid amount'
                        : reservationAmount === ''
                          ? 'Please enter the amount in AED'
                          : ''
                    }
                    inputProps={{
                      min: 0.01,
                      step: 0.01,
                    }}
                  />
                </FormControl>
              </div>
            ) : null}

            {/* First Comment Input */}
            <div>
              <div style={{ position: 'relative', marginBottom: '20px' }} className="my-2">
                <svg
                  viewBox="0 0 24 24"
                  fill="#999"
                  width="20"
                  height="20"
                  style={{
                    position: 'absolute',
                    top: '16px',
                    left: '16px',
                  }}
                >
                  <path d="M21 6h-2v9H5v2h14v3l4-4-4-4v3zM3 17h2V8h14V6H5V3L1 7l4 4z" />
                </svg>

                <textarea
                  value={firstcomment}
                  onChange={onfirstcommentchange}
                  rows={4}
                  placeholder="Write your first comment here..."
                  style={{
                    width: '100%',
                    padding: '14px 16px 14px 44px',
                    borderRadius: '10px',
                    border: '1px solid #ccc',
                    fontSize: '15px',
                    fontFamily: 'inherit',
                    resize: 'vertical',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                    outline: 'none',
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#4A90E2';
                    e.target.style.boxShadow = '0 0 0 3px rgba(74,144,226,0.2)';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#ccc';
                    e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.05)';
                  }}
                />
              </div>

              {/* Popup for first comment */}
              {firstcomment && (
                <div
                  style={{
                    position: 'fixed',
                    bottom: '10px',
                    right: '20px',
                    backgroundColor: '#0F7687',
                    color: '#fff',
                    padding: '10px 15px',
                    borderRadius: '10px',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                    maxWidth: '450px',
                    fontSize: '14px',
                    cursor: 'text',
                    outline: 'none',
                    zIndex: '1000',
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '10px',
                    wordBreak: 'break-word',
                    whiteSpace: 'pre-wrap',
                  }}
                >
                  <span style={{ fontWeight: 'bold', userSelect: 'none', pointerEvents: 'none' }}>
                    First📩
                  </span>

                  <div
                    contentEditable
                    suppressContentEditableWarning
                    onInput={onPopupfirstcommentchangeChange}
                    style={{
                      flex: 1,
                      outline: 'none',
                      wordBreak: 'break-word',
                      whiteSpace: 'pre-wrap',
                      overflowWrap: 'break-word',
                    }}
                  >
                    {firstcomment}
                  </div>
                </div>
              )}
            </div>
          </div>

          <div>
            {/* Second Comment Input */}
            <div style={{ position: 'relative', marginBottom: '20px' }} className="my-2">
              <svg
                viewBox="0 0 24 24"
                fill="#999"
                width="20"
                height="20"
                style={{
                  position: 'absolute',
                  top: '16px',
                  left: '16px',
                }}
              >
                <path d="M21 6h-2v9H5v2h14v3l4-4-4-4v3zM3 17h2V8h14V6H5V3L1 7l4 4z" />
              </svg>

              <textarea
                value={secondcomment}
                onChange={onsecondcommentchange}
                rows={4}
                id="name"
                name="Note"
                placeholder="Next Action (Plan)..."
                style={{
                  width: '100%',
                  padding: '12px 16px 12px 44px',
                  borderRadius: '10px',
                  border: '1px solid #ccc',
                  fontSize: '15px',
                  fontFamily: 'inherit',
                  resize: 'vertical',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                  outline: 'none',
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#4A90E2';
                  e.target.style.boxShadow = '0 0 0 3px rgba(74,144,226,0.2)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#ccc';
                  e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.05)';
                }}
              />
            </div>

            {/* Popup for second comment */}
            <div>
              {secondcomment && (
                <div
                  style={{
                    position: 'fixed',
                    bottom: '10px',
                    left: '20px',
                    backgroundColor: '#0F7687',
                    color: '#fff',
                    padding: '10px 15px',
                    borderRadius: '10px',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                    maxWidth: '450px',
                    fontSize: '14px',
                    cursor: 'text',
                    outline: 'none',
                    zIndex: '1000',
                    display: 'flex',
                    alignItems: 'flex-end center',
                    gap: '10px',
                  }}
                >
                  <span style={{ fontWeight: 'bold', userSelect: 'none', pointerEvents: 'none' }}>
                    Second📩
                  </span>

                  <div
                    ref={divRef}
                    contentEditable
                    suppressContentEditableWarning
                    onInput={onPopupChange}
                    onKeyUp={saveCursorPosition}
                    onMouseUp={saveCursorPosition}
                    style={{
                      flex: 1,
                      outline: 'none',
                      wordBreak: 'break-word',
                      whiteSpace: 'pre-wrap',
                      overflowWrap: 'break-word',
                    }}
                  >
                    {secondcomment}
                  </div>
                </div>
              )}
            </div>

            <div style={{ width: '100%', marginTop: '10px' }}>
              {/* button for add new comment */}
              <div
                onClick={!sendloading ? onsubmitdata : null}
                className="my-3"
                style={{
                  backgroundColor: '#102dff',
                  width: '100%',
                  height: '40px',
                  pointerEvents: sendloading ? 'none' : 'auto',
                  opacity: sendloading ? 0.6 : 1,
                  cursor: sendloading ? 'not-allowed' : 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  borderRadius: '10px',
                  color: 'white',
                  fontSize: '16px',
                  fontFamily: 'Montserrat, sans-serif',
                }}
              >
                {sendloading ? (
                  <CircularProgress size={20} style={{ color: 'white' }} />
                ) : (
                  <>
                    <AddIcon style={{ color: 'white' }} /> Add New Comment
                  </>
                )}
              </div>
            </div>
          </div>

          {/* //comments */}
          <div className="d-flex justify-content-between">
            <div
              style={{
                borderRadius: '10px',
                padding: '5px',
                fontWeight: 'bold',
                fontFamily: 'Montserrat',
                fontSize: '12px',
                color: '#102dff',
              }}
            >
              Comments ({comments?.length})
            </div>
            <br />
            <hr />
            <div
              onClick={getallactiondata}
              className="button-18"
              style={{ width: '100px', background: '#102dff', borderRadius: '10px' }}
            >
              Refresh <RefreshIcon />
            </div>
          </div>
          {isReady ? (
            comments && comments?.filter((item) => item?.Comments?.length > 0).length === 0 ? (
              <p className="text-center my-2" style={{ color: '#102dff' }}>
                <span style={{ color: '#102dff' }}>No Comments Available.</span>
                <svg
                  width="288"
                  height="213"
                  viewBox="0 0 288 213"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M63.94 58.5343L10.2227 94.4678L63.1339 173.565L116.851 137.632L63.94 58.5343Z"
                    fill="#F5F5F5"
                  />
                  <path
                    d="M89.0926 133.89L88.4845 137.663L61.7793 133.814L62.3873 130.041L89.0926 133.89Z"
                    fill="#E0E0E0"
                  />
                  <path
                    d="M75.644 120.432L79.4741 120.983L75.2275 147.276L71.3926 146.721L75.644 120.432Z"
                    fill="#E0E0E0"
                  />
                  <path
                    d="M51.0691 87.0147C51.1074 87.0674 45.7261 90.7395 39.0474 95.2015C32.3687 99.6636 26.9252 103.245 26.8869 103.187C26.8486 103.13 32.2299 99.4625 38.9086 94.9957C45.5873 90.5288 51.0069 86.9573 51.0691 87.0147Z"
                    fill="#E0E0E0"
                  />
                  <path
                    d="M70.8036 82.0547C70.8419 82.1122 61.8891 88.1637 50.8106 95.5749C39.732 102.986 30.7026 108.947 30.6739 108.894C30.6452 108.841 39.5788 102.78 50.6717 95.3691C61.7646 87.9578 70.7653 81.9973 70.8036 82.0547Z"
                    fill="#E0E0E0"
                  />
                  <path
                    d="M74.7626 87.9725C74.8009 88.0299 65.8481 94.0862 54.7695 101.497C43.691 108.909 34.6616 114.869 34.6329 114.812C34.6042 114.754 43.5474 108.703 54.6307 101.287C65.714 93.8708 74.7243 87.915 74.7626 87.9725Z"
                    fill="#E0E0E0"
                  />
                  <path
                    d="M78.7221 93.8946C78.7604 93.952 69.8075 100.008 58.729 107.415C47.6505 114.821 38.6211 120.791 38.6211 120.734C38.6211 120.676 47.5308 114.62 58.6141 107.209C69.6974 99.7977 78.6838 93.8371 78.7221 93.8946Z"
                    fill="#E0E0E0"
                  />
                  <path
                    d="M82.6679 99.8166C82.7062 99.874 73.7534 105.926 62.6749 113.337C51.5964 120.748 42.567 126.709 42.543 126.651C42.5191 126.594 51.4671 120.542 62.56 113.131C73.6529 105.72 82.6679 99.7591 82.6679 99.8166Z"
                    fill="#E0E0E0"
                  />
                  <path
                    d="M243.565 111.534L198.451 141.713L242.887 208.14L288.001 177.962L243.565 111.534Z"
                    fill="#F5F5F5"
                  />
                  <path
                    d="M264.692 174.834L264.18 178.004L241.75 174.772L242.267 171.603L264.692 174.834Z"
                    fill="#E0E0E0"
                  />
                  <path
                    d="M253.398 163.531L256.615 163.995L253.048 186.075L249.826 185.611L253.398 163.531Z"
                    fill="#E0E0E0"
                  />
                  <path
                    d="M232.74 135.49C232.778 135.547 228.263 138.635 222.652 142.384C217.041 146.133 212.464 149.13 212.426 149.087C212.388 149.043 216.907 145.946 222.513 142.192C228.12 138.439 232.702 135.408 232.74 135.49Z"
                    fill="#E0E0E0"
                  />
                  <path
                    d="M249.328 131.3C249.367 131.358 241.855 136.452 232.572 142.671C223.289 148.89 215.691 153.898 215.652 153.84C215.614 153.783 223.126 148.689 232.409 142.465C241.692 136.241 249.276 131.243 249.328 131.3Z"
                    fill="#E0E0E0"
                  />
                  <path
                    d="M252.657 136.269C252.695 136.327 245.183 141.421 235.9 147.645C226.617 153.869 219.019 158.867 218.981 158.809C218.942 158.752 226.43 153.682 235.737 147.458C245.044 141.234 252.628 136.217 252.657 136.269Z"
                    fill="#E0E0E0"
                  />
                  <path
                    d="M255.979 141.235C256.017 141.292 248.501 146.386 239.222 152.61C229.944 158.834 222.341 163.832 222.303 163.775C222.265 163.717 229.776 158.628 239.059 152.399C248.343 146.171 255.945 141.187 255.979 141.235Z"
                    fill="#E0E0E0"
                  />
                  <path
                    d="M259.33 146.219C259.369 146.276 251.857 151.365 242.574 157.589C233.291 163.813 225.693 168.811 225.654 168.759C225.616 168.706 233.128 163.607 242.411 157.383C251.694 151.159 259.268 146.161 259.33 146.219Z"
                    fill="#E0E0E0"
                  />
                  <path
                    d="M172.192 61.444L122.967 35.1161L84.1998 107.598L133.425 133.926L172.192 61.444Z"
                    fill="#F5F5F5"
                  />
                  <path
                    d="M124.999 111.25L121.877 112.317L113.949 90.4045L117.076 89.332L124.999 111.25Z"
                    fill="#E0E0E0"
                  />
                  <path
                    d="M129.788 95.5271L130.927 98.6726L109.163 106.127L108.023 102.981L129.788 95.5271Z"
                    fill="#E0E0E0"
                  />
                  <path
                    d="M145.252 63.1964C145.214 63.2682 140.225 60.6733 134.102 57.4034C127.978 54.1334 123.052 51.4189 123.09 51.347C123.128 51.2752 128.122 53.8701 134.245 57.14C140.369 60.41 145.29 63.1198 145.252 63.1964Z"
                    fill="#E0E0E0"
                  />
                  <path
                    d="M157.068 76.2328C157.029 76.3046 148.766 71.9575 138.612 66.5283C128.457 61.0992 120.261 56.6371 120.299 56.5653C120.337 56.4935 128.596 60.8359 138.75 66.2698C148.905 71.7037 157.106 76.161 157.068 76.2328Z"
                    fill="#E0E0E0"
                  />
                  <path
                    d="M154.165 81.6577C154.127 81.7295 145.864 77.3872 135.709 71.9533C125.555 66.5193 117.358 62.0621 117.397 61.9903C117.435 61.9184 125.694 66.2656 135.848 71.6947C146.003 77.1239 154.204 81.5859 154.165 81.6577Z"
                    fill="#E0E0E0"
                  />
                  <path
                    d="M151.265 87.0819C151.227 87.1537 142.963 82.8114 132.809 77.3822C122.654 71.9531 114.458 67.5054 114.496 67.4192C114.535 67.333 122.793 71.6898 132.948 77.1189C143.102 82.548 151.303 87.0101 151.265 87.0819Z"
                    fill="#E0E0E0"
                  />
                  <path
                    d="M148.363 92.5063C148.324 92.5782 140.061 88.2358 129.907 82.8067C119.752 77.3775 111.551 72.9155 111.594 72.8437C111.637 72.7718 119.891 77.1142 130.045 82.5433C140.2 87.9725 148.401 92.4345 148.363 92.5063Z"
                    fill="#E0E0E0"
                  />
                  <path
                    opacity="0.2"
                    d="M148.618 0.000244141H147.383V21.0561H148.618V0.000244141Z"
                    fill="black"
                  />
                  <path
                    d="M119.164 46.5307H176.836C176.836 46.5307 171.512 21.0654 147.564 21.0654C126.264 21.0654 119.164 46.5307 119.164 46.5307Z"
                    fill="#5F9CB1"
                  />
                  <path
                    d="M148.618 0.000244141H147.383V21.0561H148.618V0.000244141Z"
                    fill="#5F9CB1"
                  />
                  <path
                    d="M276.407 210.574C276.407 210.641 214.528 210.698 138.209 210.698C61.8893 210.698 0 210.655 0 210.574C0 210.492 61.8702 210.449 138.209 210.449C214.547 210.449 276.407 210.502 276.407 210.574Z"
                    fill="#263238"
                  />
                  <path
                    d="M15.3013 180.588C16.1107 180.646 16.9001 180.867 17.6223 181.237C18.3445 181.608 18.9847 182.119 19.5048 182.742C20.5388 183.996 21.271 185.47 21.6448 187.051C22.4539 190.077 21.956 193.653 21.0943 196.665C17.8195 195.492 15.7944 191.997 14.8704 190.158C13.4341 187.257 12.5771 181.129 15.2869 180.583"
                    fill="#5F9CB1"
                  />
                  <path
                    d="M25.8088 200.337C25.317 199.575 25.0358 198.695 24.9938 197.789C24.9518 196.883 25.1504 195.981 25.5694 195.176C26.0016 194.379 26.5883 193.676 27.2952 193.108C28.0021 192.54 28.8151 192.118 29.6867 191.868C30.4863 191.619 31.4151 191.519 32.1093 191.983C32.4222 192.22 32.6659 192.536 32.815 192.899C32.964 193.262 33.013 193.658 32.9567 194.046C32.831 194.824 32.5005 195.555 31.9992 196.163C30.4049 198.322 28.4707 200.117 25.7753 200.337"
                    fill="#5F9CB1"
                  />
                  <path
                    d="M26.1737 210.453C26.1026 210.25 26.0529 210.04 26.0253 209.826C25.9391 209.376 25.8242 208.797 25.6854 208.103C25.2556 206.202 25.136 204.244 25.3311 202.305C25.5568 200.356 26.2989 198.504 27.4807 196.938C27.8418 196.47 28.2581 196.047 28.7207 195.679C28.8464 195.579 28.9774 195.486 29.1133 195.401C29.1565 195.365 29.2049 195.336 29.2569 195.315C28.6513 195.832 28.0981 196.408 27.6052 197.034C26.4857 198.601 25.7808 200.426 25.5561 202.338C25.2497 204.569 25.6279 206.614 25.8481 208.083C25.963 208.816 26.0588 209.41 26.1115 209.821C26.1492 210.03 26.17 210.241 26.1737 210.453Z"
                    fill="#263238"
                  />
                  <path
                    d="M16.3535 185.199C16.4082 185.274 16.4532 185.356 16.4876 185.443C16.5737 185.635 16.6886 185.874 16.8227 186.176C17.1147 186.812 17.5217 187.736 18.0148 188.881C19.0011 191.174 20.3224 194.362 21.7013 197.915C23.0801 201.467 24.2531 204.708 25.0526 207.069C25.4643 208.247 25.7851 209.204 26.0101 209.869C26.1107 210.185 26.1873 210.439 26.2495 210.636C26.2837 210.723 26.3077 210.815 26.3213 210.908C26.2728 210.827 26.2342 210.74 26.2064 210.65C26.1346 210.458 26.0436 210.209 25.9239 209.898L24.9137 207.121C24.0568 204.78 22.8599 201.544 21.4858 197.996C20.1118 194.449 18.8096 191.251 17.8616 188.943C17.3829 187.808 17.0142 186.884 16.7413 186.209C16.6168 185.903 16.5163 185.659 16.4397 185.462C16.4037 185.377 16.3749 185.289 16.3535 185.199Z"
                    fill="#263238"
                  />
                  <path
                    d="M22.2815 203.761C21.2963 202.12 19.935 200.738 18.31 199.728C16.6849 198.719 14.8429 198.11 12.9361 197.953C11.9786 197.886 10.8008 198.049 10.3699 198.911C9.93903 199.772 10.5135 200.826 11.1742 201.525C12.578 202.993 14.3851 204.013 16.3677 204.456C18.3503 204.899 20.4197 204.746 22.315 204.014"
                    fill="#5F9CB1"
                  />
                  <path
                    d="M14.4102 200.547C14.6132 200.537 14.8166 200.545 15.0182 200.571C15.2542 200.584 15.4893 200.611 15.722 200.653C15.9949 200.705 16.3156 200.734 16.6508 200.83C17.0254 200.909 17.3947 201.011 17.7567 201.136C18.1761 201.271 18.587 201.431 18.9871 201.615C19.9075 202.027 20.7781 202.543 21.582 203.152C22.3767 203.775 23.0964 204.489 23.7269 205.278C23.9991 205.621 24.2501 205.981 24.4785 206.355C24.6849 206.678 24.8735 207.012 25.0434 207.355C25.1873 207.635 25.3152 207.923 25.4265 208.217C25.5224 208.435 25.604 208.659 25.6706 208.887C25.7415 209.078 25.7944 209.276 25.8286 209.476C25.7759 209.476 25.5461 208.653 24.8998 207.427C24.7238 207.098 24.5304 206.778 24.3205 206.47C24.0872 206.107 23.8347 205.757 23.5641 205.421C22.3118 203.874 20.7149 202.641 18.9009 201.821C18.4844 201.639 18.0871 201.467 17.6993 201.342C17.3432 201.212 16.9804 201.102 16.6125 201.012C15.2719 200.643 14.4054 200.6 14.4102 200.547Z"
                    fill="#263238"
                  />
                  <path
                    d="M231.735 50.4999C230.328 50.8206 229.643 52.4436 229.509 53.8799C229.375 55.3162 229.557 56.8386 228.954 58.1504C228.274 59.625 226.651 60.7166 226.598 62.3396C226.565 63.3306 227.153 64.2546 227.125 65.2552C227.077 66.883 225.42 68.1278 225.329 69.7364C225.267 70.9094 226.048 72.0297 225.861 73.1883C225.717 74.0884 225.013 74.7969 224.717 75.6587C224.128 77.3822 225.31 79.2733 226.847 80.2404C227.708 80.7818 228.677 81.1285 229.686 81.2565C230.695 81.3846 231.719 81.2907 232.688 80.9816C233.657 80.6725 234.547 80.1555 235.295 79.4668C236.043 78.7781 236.632 77.9344 237.021 76.9945C237.873 74.9262 237.686 72.5946 237.499 70.3684C236.925 63.4232 236.497 56.4684 236.216 49.504"
                    fill="#263238"
                  />
                  <path
                    d="M227.646 75.0024C227.936 74.8224 228.162 74.5562 228.293 74.2412C228.431 73.8665 228.486 73.4664 228.456 73.0682C228.403 72.5404 228.286 72.021 228.106 71.5219C227.877 70.8945 227.792 70.2236 227.857 69.5589C227.977 68.8121 228.513 68.1993 228.997 67.596C229.257 67.3008 229.475 66.9704 229.643 66.6146C229.812 66.2547 229.839 65.8446 229.72 65.4655C229.471 64.6852 228.705 64.1106 228.355 63.2058C228.191 62.7578 228.164 62.271 228.278 61.8078C228.387 61.3735 228.548 60.9539 228.757 60.5582C229.161 59.8456 229.483 59.089 229.715 58.3033C230.05 56.7856 229.892 55.335 230.122 54.1429C230.249 53.1881 230.673 52.2973 231.333 51.5958C231.52 51.4069 231.732 51.2457 231.965 51.1171C232.045 51.0753 232.13 51.0447 232.219 51.0261C231.919 51.1913 231.643 51.3976 231.4 51.6389C230.788 52.3474 230.403 53.2229 230.294 54.1524C230.21 54.7874 230.165 55.427 230.16 56.0675C230.159 56.8212 230.085 57.5732 229.94 58.3129C229.711 59.1167 229.39 59.8911 228.982 60.6205C228.623 61.3721 228.293 62.2531 228.609 63.0765C228.925 63.9 229.686 64.4697 229.978 65.3506C230.11 65.7858 230.078 66.2543 229.887 66.6672C229.701 67.0588 229.459 67.4216 229.169 67.7444C228.69 68.3477 228.168 68.9222 228.053 69.5924C227.986 70.2282 228.062 70.8709 228.274 71.474C228.445 71.9886 228.551 72.5226 228.59 73.0635C228.613 73.48 228.54 73.8964 228.374 74.2795C228.271 74.5197 228.106 74.728 227.895 74.8828C227.821 74.9376 227.736 74.9782 227.646 75.0024Z"
                    fill="#455A64"
                  />
                  <path
                    d="M223.902 86.3541L219.594 98.8019L201.573 99.7594L198.566 106.462L217.382 108.377C218.271 108.742 219.224 108.923 220.185 108.909C221.146 108.895 222.094 108.686 222.972 108.296C223.85 107.905 224.64 107.341 225.293 106.636C225.947 105.932 226.451 105.102 226.775 104.198L231.797 90.1794L223.902 86.3541Z"
                    fill="#B78876"
                  />
                  <path
                    d="M261.154 203.809C261.154 203.809 247.95 161.86 247.668 160.5C247.414 159.265 252.455 129.079 253.097 121.242L235.253 121.907V122.084L227.67 122.506L234.459 208.261H242.669L241.856 179.799C246.921 193.391 254.179 207.246 254.179 207.246L261.154 203.809Z"
                    fill="#B78876"
                  />
                  <path
                    d="M242.191 190.01C242.191 189.752 242.091 180.473 242.091 180.473C241.99 181.029 238.945 172.421 239.017 171.899C239.055 171.626 242.191 190.01 242.191 190.01Z"
                    fill="#A36957"
                  />
                  <path
                    d="M238.672 167.82C238.63 167.991 238.612 168.166 238.619 168.342C238.593 168.82 238.593 169.3 238.619 169.778C238.619 170.08 238.663 170.405 238.701 170.76C238.739 171.114 238.792 171.487 238.873 171.875C239.043 172.722 239.269 173.557 239.548 174.374C240.142 176.112 240.803 177.63 241.267 178.731C241.487 179.21 241.679 179.665 241.842 180.028C241.9 180.198 241.981 180.359 242.081 180.507C242.055 180.342 242.007 180.181 241.937 180.028C241.827 179.712 241.66 179.258 241.459 178.698C241.037 177.577 240.405 176.045 239.816 174.326C239.538 173.521 239.309 172.699 239.132 171.866C239.046 171.483 238.988 171.114 238.935 170.769C238.883 170.425 238.844 170.099 238.821 169.812C238.763 169.218 238.739 168.739 238.725 168.404C238.734 168.208 238.716 168.011 238.672 167.82Z"
                    fill="#A36957"
                  />
                  <path
                    d="M234.306 208.696V207.926L242.717 207.557L242.741 210.741L242.224 210.774C239.912 210.908 230.471 211.301 228.929 210.836C227.201 210.319 234.306 208.696 234.306 208.696Z"
                    fill="#455A64"
                  />
                  <path
                    d="M242.852 210.549C242.805 210.552 242.757 210.552 242.709 210.549L242.297 210.578L240.775 210.645C239.491 210.698 237.715 210.746 235.757 210.755C233.799 210.765 232.018 210.731 230.73 210.693L229.213 210.631H228.796H228.652C228.7 210.627 228.748 210.627 228.796 210.631H229.213L230.735 210.659C232.018 210.659 233.794 210.698 235.752 210.688C237.71 210.679 239.491 210.645 240.775 210.612L242.297 210.573H242.852V210.549Z"
                    fill="#263238"
                  />
                  <path
                    d="M231.563 210.818C231.493 210.567 231.397 210.325 231.276 210.095C231.124 209.882 230.949 209.688 230.754 209.515C231.015 209.609 231.232 209.797 231.362 210.042C231.52 210.268 231.592 210.543 231.563 210.818Z"
                    fill="#263238"
                  />
                  <path
                    d="M234.042 209.558C234.042 209.558 233.904 209.429 233.779 209.238C233.655 209.046 233.578 208.879 233.602 208.864C233.626 208.85 233.741 208.989 233.865 209.18C233.99 209.372 234.066 209.544 234.042 209.558Z"
                    fill="#263238"
                  />
                  <path
                    d="M234.722 209.218C234.722 209.242 234.569 209.151 234.425 209.022C234.282 208.893 234.176 208.773 234.196 208.754C234.215 208.735 234.349 208.821 234.492 208.95C234.636 209.079 234.741 209.175 234.722 209.218Z"
                    fill="#263238"
                  />
                  <path
                    d="M235.148 208.404C235.007 208.456 234.856 208.475 234.707 208.462C234.561 208.481 234.411 208.466 234.271 208.419C234.411 208.367 234.559 208.348 234.707 208.361C234.855 208.341 235.006 208.356 235.148 208.404Z"
                    fill="#263238"
                  />
                  <path
                    d="M235.292 207.849C235.149 207.942 234.983 207.991 234.813 207.993C234.65 208.014 234.485 207.991 234.334 207.926C234.492 207.899 234.652 207.886 234.813 207.887C234.971 207.859 235.131 207.846 235.292 207.849Z"
                    fill="#263238"
                  />
                  <path
                    d="M233.76 208.826C233.581 208.859 233.398 208.859 233.219 208.826C233.025 208.802 232.835 208.761 232.649 208.701C232.534 208.67 232.423 208.625 232.319 208.567C232.255 208.53 232.207 208.47 232.185 208.4C232.176 208.36 232.179 208.318 232.193 208.28C232.208 208.242 232.233 208.208 232.266 208.184C232.399 208.12 232.544 208.086 232.691 208.085C232.838 208.083 232.984 208.115 233.118 208.177C233.252 208.238 233.37 208.329 233.464 208.442C233.559 208.555 233.627 208.688 233.664 208.831C233.674 208.878 233.674 208.927 233.664 208.974C233.61 208.801 233.526 208.639 233.415 208.495C233.288 208.352 233.121 208.249 232.936 208.199C232.724 208.13 232.494 208.147 232.295 208.247C232.213 208.309 232.247 208.409 232.338 208.467C232.436 208.52 232.538 208.563 232.644 208.596C232.824 208.655 233.008 208.702 233.195 208.735C233.554 208.811 233.76 208.811 233.76 208.826Z"
                    fill="#263238"
                  />
                  <path
                    d="M233.621 208.855C233.551 208.744 233.527 208.61 233.554 208.482C233.571 208.341 233.622 208.206 233.702 208.089C233.747 208.009 233.811 207.942 233.889 207.893C233.967 207.845 234.056 207.816 234.147 207.811C234.202 207.824 234.249 207.857 234.28 207.903C234.311 207.949 234.324 208.005 234.315 208.06C234.303 208.146 234.272 208.228 234.224 208.3C234.151 208.418 234.066 208.529 233.97 208.63C233.887 208.725 233.782 208.799 233.664 208.845C233.664 208.845 233.769 208.75 233.918 208.577C234.004 208.479 234.079 208.371 234.143 208.257C234.214 208.142 234.267 207.936 234.143 207.912C234.018 207.888 233.874 208.036 233.793 208.142C233.717 208.245 233.665 208.365 233.64 208.491C233.62 208.611 233.614 208.733 233.621 208.855Z"
                    fill="#263238"
                  />
                  <path
                    d="M242.674 208.261C242.674 208.261 242.435 208.261 242.057 208.285C241.564 208.344 241.098 208.54 240.711 208.85C240.325 209.161 240.033 209.574 239.869 210.042C239.744 210.401 239.735 210.645 239.716 210.64C239.696 210.636 239.716 210.578 239.716 210.473C239.728 210.319 239.757 210.166 239.802 210.018C239.954 209.528 240.247 209.093 240.644 208.769C241.047 208.45 241.535 208.258 242.047 208.218C242.206 208.199 242.367 208.199 242.526 208.218C242.577 208.226 242.627 208.24 242.674 208.261Z"
                    fill="#263238"
                  />
                  <path
                    d="M238.648 209.879C238.246 209.973 237.834 210.013 237.422 209.999C237.012 210.019 236.601 209.984 236.201 209.893C236.201 209.865 236.747 209.893 237.422 209.893C238.097 209.893 238.643 209.85 238.648 209.879Z"
                    fill="#263238"
                  />
                  <path
                    d="M240.284 209.864C240.284 209.864 240.241 209.979 240.184 210.104C240.126 210.228 240.098 210.343 240.069 210.338C240.04 210.334 240.026 210.209 240.093 210.061C240.16 209.912 240.265 209.84 240.284 209.864Z"
                    fill="#263238"
                  />
                  <path
                    d="M240.903 209.094C240.903 209.094 240.87 209.199 240.784 209.285C240.698 209.372 240.611 209.429 240.587 209.41C240.564 209.391 240.621 209.305 240.707 209.214C240.793 209.123 240.88 209.07 240.903 209.094Z"
                    fill="#263238"
                  />
                  <path
                    d="M241.783 208.74C241.783 208.768 241.668 208.768 241.544 208.811C241.419 208.855 241.333 208.922 241.309 208.902C241.285 208.883 241.357 208.768 241.51 208.716C241.664 208.663 241.793 208.711 241.783 208.74Z"
                    fill="#263238"
                  />
                  <path
                    d="M242.41 208.567C242.41 208.596 242.377 208.639 242.305 208.663C242.233 208.687 242.171 208.692 242.161 208.663C242.152 208.634 242.2 208.591 242.267 208.567C242.334 208.543 242.401 208.543 242.41 208.567Z"
                    fill="#263238"
                  />
                  <path
                    d="M254.011 207.955L253.695 207.251L261.217 203.473L262.543 206.346L262.064 206.59C260.01 207.658 251.56 211.88 249.961 212.091C248.194 212.345 254.011 207.955 254.011 207.955Z"
                    fill="#455A64"
                  />
                  <path
                    d="M262.572 206.14L262.447 206.216L262.079 206.408L260.719 207.097C259.57 207.667 257.971 208.438 256.185 209.252C254.399 210.065 252.762 210.76 251.575 211.253L250.162 211.823L249.779 211.971C249.735 211.991 249.689 212.006 249.641 212.014L249.77 211.952L250.148 211.784L251.546 211.186C252.729 210.678 254.356 209.97 256.142 209.156C257.928 208.342 259.532 207.585 260.69 207.03L262.06 206.374L262.438 206.197L262.572 206.14Z"
                    fill="#263238"
                  />
                  <path
                    d="M252.399 211.009C252.233 210.807 252.045 210.624 251.838 210.464C251.614 210.331 251.374 210.225 251.125 210.148C251.4 210.144 251.669 210.225 251.897 210.379C252.125 210.533 252.3 210.753 252.399 211.009Z"
                    fill="#263238"
                  />
                  <path
                    d="M254.126 208.845C254.126 208.845 253.944 208.788 253.753 208.663C253.561 208.539 253.422 208.419 253.437 208.395C253.451 208.371 253.618 208.452 253.81 208.577C254.001 208.701 254.14 208.821 254.126 208.845Z"
                    fill="#263238"
                  />
                  <path
                    d="M254.596 208.261C254.596 208.284 254.433 208.261 254.247 208.203C254.06 208.146 253.921 208.074 253.926 208.045C254.047 208.034 254.169 208.054 254.28 208.103C254.462 208.146 254.606 208.213 254.596 208.261Z"
                    fill="#263238"
                  />
                  <path
                    d="M254.662 207.342C254.662 207.371 254.504 207.471 254.284 207.576C254.157 207.653 254.015 207.7 253.867 207.715C253.867 207.687 254.025 207.586 254.241 207.481C254.369 207.405 254.513 207.357 254.662 207.342Z"
                    fill="#263238"
                  />
                  <path
                    d="M254.568 206.776C254.568 206.776 254.429 206.968 254.18 207.107C254.039 207.203 253.872 207.253 253.701 207.25C253.838 207.158 253.984 207.08 254.137 207.016C254.371 206.887 254.544 206.753 254.568 206.776Z"
                    fill="#263238"
                  />
                  <path
                    d="M253.586 208.299C253.44 208.4 253.278 208.474 253.108 208.52C252.919 208.574 252.727 208.614 252.533 208.639C252.415 208.654 252.296 208.654 252.179 208.639C252.105 208.634 252.036 208.599 251.987 208.544C251.965 208.509 251.953 208.469 251.953 208.429C251.953 208.388 251.965 208.348 251.987 208.314C252.133 208.137 252.335 208.017 252.559 207.973C252.784 207.93 253.017 207.965 253.218 208.074C253.336 208.137 253.441 208.223 253.524 208.328C253.581 208.405 253.605 208.453 253.601 208.457C253.483 208.326 253.341 208.217 253.184 208.137C253.016 208.057 252.828 208.029 252.643 208.055C252.533 208.067 252.427 208.1 252.33 208.152C252.233 208.205 252.148 208.276 252.078 208.362C252.025 208.453 252.078 208.529 252.207 208.544C252.317 208.553 252.428 208.553 252.538 208.544C252.728 208.524 252.917 208.491 253.103 208.443C253.376 208.366 253.586 208.285 253.586 208.299Z"
                    fill="#263238"
                  />
                  <path
                    d="M253.451 208.38C253.344 208.304 253.269 208.192 253.24 208.064C253.198 207.93 253.188 207.787 253.211 207.648C253.22 207.556 253.251 207.468 253.303 207.391C253.355 207.315 253.426 207.253 253.508 207.212C253.628 207.174 253.906 207.418 253.925 207.509C253.944 207.6 253.786 207.552 253.776 207.629C253.761 207.764 253.729 207.898 253.681 208.026C253.646 208.149 253.58 208.261 253.489 208.352C253.489 208.352 253.547 208.222 253.614 208.007C253.648 207.88 253.672 207.75 253.685 207.619C253.685 207.485 253.685 207.279 253.532 207.313C253.379 207.346 253.336 207.533 253.302 207.667C253.273 207.791 253.273 207.921 253.302 208.045C253.342 208.161 253.392 208.273 253.451 208.38Z"
                    fill="#263238"
                  />
                  <path
                    d="M261.47 204.124C261.47 204.124 261.24 204.205 260.915 204.402C260.489 204.656 260.143 205.024 259.914 205.465C259.693 205.909 259.598 206.406 259.641 206.901C259.67 207.284 259.761 207.504 259.742 207.514C259.711 207.466 259.687 207.415 259.67 207.36C259.623 207.214 259.589 207.063 259.569 206.91C259.501 206.401 259.589 205.882 259.823 205.423C260.056 204.965 260.424 204.589 260.876 204.344C261.012 204.269 261.155 204.208 261.303 204.162C261.356 204.141 261.413 204.129 261.47 204.124Z"
                    fill="#263238"
                  />
                  <path
                    d="M258.459 207.256C257.784 207.725 257.029 208.069 256.232 208.271C256.232 208.242 256.735 208.05 257.348 207.792C257.961 207.533 258.444 207.232 258.459 207.256Z"
                    fill="#263238"
                  />
                  <path
                    d="M259.947 206.571C259.971 206.571 259.947 206.69 259.947 206.829C259.947 206.968 259.947 207.083 259.947 207.092C259.947 207.102 259.852 206.987 259.852 206.829C259.852 206.671 259.923 206.556 259.947 206.571Z"
                    fill="#263238"
                  />
                  <path
                    d="M260.192 205.613C260.216 205.613 260.192 205.723 260.164 205.838C260.135 205.953 260.063 206.039 260.039 206.03C260.015 206.02 260.039 205.92 260.068 205.805C260.097 205.69 260.164 205.604 260.192 205.613Z"
                    fill="#263238"
                  />
                  <path
                    d="M260.853 204.91C260.853 204.938 260.757 204.981 260.661 205.072C260.566 205.163 260.513 205.259 260.489 205.25C260.465 205.24 260.489 205.106 260.594 204.996C260.7 204.886 260.848 204.91 260.853 204.91Z"
                    fill="#263238"
                  />
                  <path
                    d="M261.356 204.517C261.356 204.517 261.356 204.594 261.299 204.646C261.241 204.699 261.188 204.728 261.169 204.708C261.15 204.689 261.169 204.632 261.227 204.579C261.284 204.527 261.337 204.498 261.356 204.517Z"
                    fill="#263238"
                  />
                  <path
                    d="M251.938 107.07L250.54 89.978L257.721 90.1073C257.721 90.1073 258.052 87.5842 256.994 82.0593C256.343 78.6697 254.088 76.5919 251.555 75.3567V75.3088L251.335 75.2513C249.25 74.3153 247.023 73.7344 244.747 73.5326L235.914 73.6331C235.914 73.6331 229.168 72.7714 225.448 77.6021C224.012 79.4549 219.555 92.1372 219.555 92.1372L230.159 97.2408L229.168 90.2078C229.168 90.2078 229.369 95.3066 230.02 96.9105C230.379 97.8105 231.457 100.606 231.457 100.606L231.318 109.042L251.938 107.07Z"
                    fill="#5F9CB1"
                  />
                  <path
                    d="M247.07 87.4983L245.758 93.0806H258.124L257.31 83.7161L247.07 87.4983Z"
                    fill="#5F9CB1"
                  />
                  <path
                    d="M258.125 93.0805C257.585 92.9809 257.037 92.9265 256.487 92.9177C255.473 92.8603 254.094 92.8076 252.523 92.8172C250.953 92.8267 249.569 92.8938 248.554 92.9704C248.005 92.9895 247.459 93.0568 246.922 93.1715C247.47 93.2151 248.021 93.2151 248.569 93.1715C249.579 93.1379 250.963 93.0996 252.523 93.0949C254.084 93.0901 255.468 93.0949 256.483 93.1188C257.03 93.1495 257.579 93.1367 258.125 93.0805Z"
                    fill="#263238"
                  />
                  <path
                    d="M246.533 83.6732C246.474 84.1496 246.461 84.6306 246.495 85.1095C246.495 85.9856 246.533 87.1921 246.586 88.5278C246.638 89.8636 246.701 91.0749 246.758 91.9462C246.76 92.4289 246.812 92.9101 246.911 93.3825C246.97 92.9061 246.983 92.4251 246.95 91.9462C246.95 91.0701 246.911 89.8588 246.859 88.5231C246.806 87.1873 246.744 85.9808 246.686 85.1047C246.684 84.6236 246.633 84.1439 246.533 83.6732Z"
                    fill="#263238"
                  />
                  <g opacity="0.3">
                    <path
                      d="M235.281 88.509C235.281 88.509 238.029 108.89 245.757 108.349C245.757 108.349 249.237 108.311 250.353 105.998V105.089L235.281 88.509Z"
                      fill="black"
                    />
                  </g>
                  <g opacity="0.3">
                    <path
                      d="M246.532 84.8744L245.053 94.8661L246.01 96.6184L247.59 93.1905L246.92 93.1713L246.532 84.8744Z"
                      fill="black"
                    />
                  </g>
                  <path
                    d="M231.413 100.617C231.322 100.467 231.251 100.306 231.203 100.138C231.083 99.8265 230.925 99.3717 230.724 98.802C230.245 97.3175 229.85 95.807 229.541 94.2777C229.234 92.7476 229.039 91.1971 228.957 89.6385C228.929 89.0401 228.919 88.5565 228.929 88.2022C228.916 88.0292 228.928 87.8552 228.962 87.6852C229 87.6852 229.029 88.4225 229.13 89.6002C229.264 91.1446 229.483 92.6806 229.786 94.2011C230.14 95.9821 230.566 97.5764 230.892 98.7206C231.045 99.252 231.174 99.7069 231.279 100.08C231.345 100.253 231.39 100.433 231.413 100.617Z"
                    fill="#263238"
                  />
                  <path
                    d="M234.535 106.471C234.468 106.471 234.276 106.055 234.109 105.514C233.965 105.182 233.901 104.822 233.922 104.461C234.133 104.753 234.279 105.088 234.348 105.442C234.485 105.767 234.549 106.119 234.535 106.471Z"
                    fill="#263238"
                  />
                  <path
                    d="M235.603 106.395C235.241 105.435 235.226 104.378 235.56 103.408C235.598 103.905 235.598 104.404 235.56 104.902C235.612 105.398 235.627 105.897 235.603 106.395Z"
                    fill="#263238"
                  />
                  <path
                    d="M230.374 97.4761C230.341 97.5335 227.875 96.3653 224.864 94.862C221.852 93.3587 219.434 92.0852 219.463 92.023C219.492 91.9608 221.962 93.1337 224.974 94.637C227.985 96.1403 230.403 97.4138 230.374 97.4761Z"
                    fill="#263238"
                  />
                  <path
                    d="M234.722 75.2849C234.775 72.8623 234.789 70.3153 234.789 70.3153C234.789 70.3153 231.682 69.7169 231.141 65.6283C230.624 61.7311 232.07 52.582 232.07 52.582C236.608 50.8681 241.324 52.424 244.431 56.1009L243.661 75.7636C243.57 78.0473 241.535 79.79 239.093 79.6751C236.623 79.5554 234.669 77.5925 234.722 75.2849Z"
                    fill="#B78876"
                  />
                  <path
                    d="M231.83 59.8933C231.826 60.0275 231.873 60.1583 231.962 60.2589C232.051 60.3594 232.175 60.4222 232.309 60.4343C232.377 60.4409 232.446 60.4335 232.511 60.4127C232.576 60.3919 232.636 60.3581 232.687 60.3133C232.739 60.2685 232.781 60.2137 232.81 60.1522C232.84 60.0907 232.857 60.0238 232.86 59.9556C232.864 59.8219 232.816 59.6917 232.727 59.5919C232.638 59.4921 232.514 59.4303 232.381 59.4194C232.313 59.409 232.243 59.4135 232.177 59.4326C232.11 59.4517 232.049 59.4849 231.997 59.5299C231.944 59.5749 231.903 59.6307 231.874 59.6934C231.845 59.7561 231.83 59.8243 231.83 59.8933Z"
                    fill="#263238"
                  />
                  <path
                    d="M231.64 59.2089C231.702 59.2759 232.118 58.9934 232.669 59.0126C233.219 59.0317 233.626 59.319 233.693 59.2519C233.76 59.1849 233.665 59.0987 233.488 58.9599C233.248 58.7862 232.96 58.6909 232.664 58.687C232.372 58.6759 232.085 58.7599 231.845 58.9264C231.668 59.0557 231.606 59.1753 231.64 59.2089Z"
                    fill="#263238"
                  />
                  <path
                    d="M237.532 60.247C237.526 60.3815 237.573 60.5129 237.662 60.6137C237.752 60.7145 237.876 60.777 238.01 60.788C238.079 60.7984 238.149 60.7938 238.216 60.7744C238.282 60.7551 238.344 60.7214 238.396 60.6759C238.449 60.6304 238.491 60.574 238.519 60.5107C238.548 60.4473 238.562 60.3786 238.561 60.3092C238.566 60.1752 238.519 60.0443 238.43 59.9443C238.341 59.8442 238.216 59.7828 238.082 59.773C238.014 59.7626 237.944 59.7672 237.878 59.7862C237.812 59.8053 237.75 59.8385 237.698 59.8835C237.646 59.9285 237.604 59.9843 237.575 60.047C237.546 60.1098 237.532 60.178 237.532 60.247Z"
                    fill="#263238"
                  />
                  <path
                    d="M237.495 59.5628C237.557 59.6346 237.974 59.3521 238.524 59.3665C239.075 59.3808 239.482 59.6729 239.554 59.6058C239.625 59.5388 239.52 59.4526 239.343 59.3186C239.107 59.1404 238.82 59.043 238.524 59.0409C238.231 59.0321 237.943 59.1159 237.701 59.2803C237.529 59.4096 237.466 59.5292 237.495 59.5628Z"
                    fill="#263238"
                  />
                  <path
                    d="M235.349 63.6756C235.055 63.5746 234.749 63.5118 234.439 63.4889C234.296 63.4889 234.162 63.4363 234.143 63.3405C234.131 63.1908 234.168 63.0414 234.248 62.9144L234.698 61.8372C235.117 60.9217 235.461 59.9738 235.727 59.0029C235.237 59.8826 234.817 60.7999 234.473 61.7462C234.324 62.1244 234.176 62.4883 234.037 62.833C233.944 63.0041 233.914 63.2021 233.951 63.3932C233.97 63.4451 234 63.4919 234.04 63.5301C234.08 63.5683 234.128 63.5968 234.181 63.6134C234.26 63.6364 234.342 63.6493 234.425 63.6517C234.731 63.6988 235.041 63.7068 235.349 63.6756Z"
                    fill="#263238"
                  />
                  <path
                    d="M234.789 70.3155C236.704 70.3922 238.604 69.9364 240.276 68.9989C240.276 68.9989 238.882 71.7614 234.818 71.2778L234.789 70.3155Z"
                    fill="#A36957"
                  />
                  <path
                    d="M239.295 57.9304C239.18 58.1076 238.749 58.0309 238.271 57.9304C237.792 57.8299 237.371 57.7485 237.313 57.5426C237.256 57.3367 237.758 57.0639 238.4 57.1931C239.041 57.3224 239.41 57.7772 239.295 57.9304Z"
                    fill="#263238"
                  />
                  <path
                    d="M233.708 57.116C233.664 57.3219 233.205 57.3985 232.678 57.4224C232.152 57.4464 231.687 57.4224 231.625 57.2118C231.563 57.0011 232.008 56.7043 232.645 56.6756C233.281 56.6468 233.751 56.9197 233.708 57.116Z"
                    fill="#263238"
                  />
                  <path
                    d="M235.36 65.0203C235.299 65.006 235.236 65.0123 235.179 65.0384C235.123 65.0644 235.077 65.1086 235.049 65.1639C235.021 65.2127 235.007 65.2678 235.008 65.3237C235.008 65.3797 235.024 65.4344 235.052 65.4827C235.08 65.5309 235.121 65.5709 235.169 65.5987C235.218 65.6264 235.273 65.6411 235.329 65.6411C235.384 65.6411 235.439 65.6264 235.488 65.5987C235.536 65.5709 235.577 65.5309 235.605 65.4827C235.634 65.4344 235.649 65.3797 235.649 65.3237C235.65 65.2678 235.636 65.2127 235.609 65.1639C235.574 65.0996 235.519 65.0489 235.452 65.0202C235.385 64.9915 235.31 64.9864 235.24 65.0059"
                    fill="#A36957"
                  />
                  <path
                    d="M235.487 65.0782C235.487 65.0543 235.396 64.9155 235.152 64.9681C235.079 64.9872 235.013 65.0251 234.959 65.078C234.905 65.1309 234.866 65.197 234.846 65.2697C234.82 65.3614 234.822 65.4587 234.852 65.549C234.882 65.6394 234.938 65.7189 235.013 65.7772C235.093 65.8318 235.187 65.861 235.284 65.861C235.381 65.861 235.475 65.8318 235.554 65.7772C235.618 65.7344 235.668 65.6741 235.699 65.6037C235.729 65.5333 235.739 65.4556 235.727 65.3799C235.679 65.1261 235.492 65.0878 235.483 65.1213C235.473 65.1548 235.55 65.241 235.535 65.3894C235.532 65.4261 235.52 65.4614 235.5 65.4923C235.48 65.5232 235.453 65.5487 235.42 65.5666C235.383 65.588 235.341 65.5993 235.298 65.5993C235.255 65.5993 235.213 65.588 235.176 65.5666C235.143 65.5382 235.117 65.5017 235.102 65.4606C235.087 65.4195 235.083 65.3752 235.09 65.332C235.096 65.2942 235.11 65.2583 235.133 65.2274C235.155 65.1965 235.185 65.1716 235.219 65.1548C235.353 65.0735 235.473 65.1118 235.487 65.0782Z"
                    fill="#263238"
                  />
                  <path
                    d="M242.574 60.9032C242.095 62.0235 240.908 62.89 241.071 64.1013C241.176 64.8817 241.679 65.6094 241.583 66.3946C241.459 67.3521 240.439 68.0606 240.291 69.0421C240.113 70.2438 241.286 71.1774 241.751 72.2977C242.435 73.935 241.564 75.7735 241.54 77.564C241.568 78.9235 242.088 80.2266 243.004 81.2319C243.919 82.2372 245.168 82.8766 246.519 83.0315C247.611 83.1224 248.841 82.7921 249.392 81.8537C249.871 81.0781 249.765 80.0919 250.043 79.2349C250.464 77.9518 251.685 77.0135 251.958 75.6921C252.437 73.2983 249.516 71.2875 249.708 68.8362C249.789 67.7878 250.435 66.8781 250.708 65.8631C250.882 65.1961 250.895 64.4974 250.747 63.8242C250.599 63.151 250.294 62.5225 249.856 61.99C249.133 61.133 248.09 60.5537 247.462 59.6345C246.768 58.5764 246.744 57.2407 246.505 55.9911C246.183 54.4723 245.482 53.0598 244.467 51.8855C243.451 50.7113 242.154 49.8138 240.698 49.2767C239.241 48.7397 237.672 48.5808 236.137 48.8147C234.603 49.0487 233.152 49.668 231.922 50.6146C231.922 50.6146 231.228 53.7696 234.469 54.3011C237.71 54.8325 239.209 54.2197 239.572 55.5171C239.487 56.0516 239.529 56.5988 239.695 57.1139C239.862 57.629 240.148 58.0974 240.53 58.4807C241.851 59.9074 243.11 59.601 242.574 60.9032Z"
                    fill="#263238"
                  />
                  <path
                    d="M247.72 82.7872C247.621 82.7906 247.521 82.7809 247.424 82.7584C247.143 82.7087 246.867 82.6333 246.6 82.5334C245.612 82.1544 244.744 81.514 244.091 80.6806C243.634 80.1055 243.274 79.4584 243.029 78.7656C242.749 77.9765 242.602 77.1466 242.593 76.3095C242.583 75.3869 242.699 74.4671 242.938 73.5758C243.068 73.1051 243.228 72.643 243.416 72.1922C243.614 71.7435 243.788 71.2849 243.938 70.8182C244.07 70.3582 244.07 69.8705 243.938 69.4106C243.798 68.9578 243.617 68.5187 243.397 68.0988C243.175 67.6824 242.988 67.2484 242.837 66.8014C242.69 66.3589 242.655 65.8866 242.737 65.4273C242.928 64.5272 243.474 63.857 243.799 63.1723C244.109 62.5386 244.258 61.8378 244.23 61.1328C244.187 60.1011 243.812 59.1107 243.163 58.3081C242.911 58.027 242.641 57.7631 242.354 57.5182C242.689 57.7068 242.989 57.9531 243.239 58.2459C243.937 59.0473 244.347 60.0579 244.407 61.1185C244.447 61.8542 244.302 62.5882 243.986 63.2537C243.656 63.9623 243.124 64.6374 242.962 65.4608C242.799 66.2843 243.187 67.1508 243.613 67.9839C243.845 68.4158 244.034 68.8697 244.178 69.3388C244.319 69.8397 244.319 70.3699 244.178 70.8708C244.018 71.3538 243.835 71.8284 243.627 72.2927C243.439 72.7337 243.279 73.1863 243.148 73.6476C242.911 74.5164 242.793 75.4136 242.799 76.3143C242.784 77.8483 243.279 79.3437 244.206 80.5657C244.826 81.3887 245.652 82.0342 246.6 82.4377C247.313 82.7153 247.725 82.7584 247.72 82.7872Z"
                    fill="#455A64"
                  />
                  <path
                    d="M247.242 58.6289C247.008 58.6893 246.769 58.7246 246.528 58.7342C245.872 58.8045 245.208 58.7868 244.556 58.6815C244.062 58.6083 243.587 58.4372 243.159 58.1783C242.732 57.9193 242.36 57.5777 242.066 57.1734C241.793 56.662 241.574 56.1227 241.415 55.5648C241.211 55.0076 240.827 54.5342 240.324 54.2195C239.275 53.554 238.045 53.4726 236.972 53.3434C235.983 53.294 235.023 52.9942 234.181 52.472C233.618 52.0985 233.21 51.5313 233.037 50.8777C232.995 50.7006 232.984 50.5177 233.003 50.3367C233.003 50.2123 233.032 50.15 233.042 50.15C233.047 50.3872 233.078 50.623 233.133 50.8538C233.331 51.4649 233.738 51.9868 234.282 52.3284C235.108 52.8104 236.04 53.0801 236.996 53.1136C238.069 53.238 239.342 53.3003 240.463 54.0088C241.011 54.3531 241.429 54.8703 241.65 55.4786C241.8 56.0224 242.007 56.5487 242.267 57.049C242.825 57.8139 243.66 58.3296 244.594 58.4852C245.225 58.6026 245.868 58.646 246.509 58.6145C246.753 58.6008 246.998 58.6056 247.242 58.6289Z"
                    fill="#455A64"
                  />
                  <path
                    d="M246.054 54.7319C245.873 54.7922 245.683 54.8198 245.493 54.8133C244.601 54.8193 243.742 54.4756 243.1 53.8558C242.807 53.5621 242.557 53.2285 242.357 52.8648C241.927 52.137 241.51 51.2418 240.615 50.8683C239.752 50.579 238.833 50.4985 237.934 50.6337C237.175 50.7404 236.404 50.7404 235.645 50.6337C235.117 50.5605 234.62 50.3416 234.209 50.0018C234.103 49.9092 234.009 49.8029 233.931 49.6858C233.874 49.6028 233.85 49.5597 233.859 49.5565C233.859 49.5565 233.994 49.7097 234.271 49.9252C234.681 50.2163 235.156 50.4006 235.655 50.4614C236.4 50.5454 237.153 50.5325 237.895 50.4231C238.834 50.2697 239.797 50.352 240.696 50.6625C241.158 50.8702 241.554 51.2016 241.84 51.62C242.093 51.9932 242.325 52.38 242.535 52.7786C242.723 53.1265 242.957 53.4484 243.229 53.7361C243.469 53.9793 243.745 54.1844 244.048 54.3441C244.493 54.5766 244.982 54.7121 245.484 54.7415C245.852 54.7367 246.049 54.708 246.054 54.7319Z"
                    fill="#455A64"
                  />
                  <path
                    d="M249.148 81.7533C249.124 81.7533 249.277 81.4373 249.454 80.8436C249.694 80.0102 249.8 79.1442 249.77 78.2775C249.735 76.9946 249.385 75.7399 248.75 74.6245C248.401 73.9974 247.869 73.4372 247.434 72.7478C247.203 72.3966 247.041 72.0052 246.955 71.594C246.879 71.1612 246.916 70.7162 247.06 70.3013C247.328 69.4731 247.807 68.7789 247.912 68.0176C248.018 67.2564 247.654 66.5814 247.29 65.9446C247.102 65.6348 246.931 65.3151 246.778 64.9871C246.638 64.6689 246.546 64.3317 246.505 63.9865C246.46 63.3781 246.479 62.7667 246.562 62.1624C246.715 61.3081 246.636 60.4284 246.333 59.6154C246.197 59.3306 246.005 59.0764 245.768 58.8685C245.768 58.8685 245.792 58.8685 245.825 58.8973C245.882 58.9254 245.933 58.9626 245.978 59.0074C246.166 59.1634 246.317 59.3576 246.423 59.5771C246.77 60.3971 246.878 61.2982 246.735 62.1768C246.669 62.7698 246.661 63.3679 246.711 63.9625C246.829 64.6314 247.094 65.2659 247.486 65.8201C247.691 66.1437 247.865 66.485 248.008 66.8399C248.159 67.223 248.209 67.6386 248.152 68.0464C248.037 68.8842 247.544 69.5928 247.295 70.3731C247.164 70.7497 247.13 71.1528 247.194 71.5461C247.278 71.9265 247.43 72.2883 247.644 72.6137C248.051 73.2792 248.602 73.8489 248.951 74.5048C249.593 75.6579 249.935 76.9533 249.947 78.2727C249.962 79.1558 249.826 80.0351 249.545 80.8724C249.468 81.099 249.376 81.3198 249.267 81.533C249.238 81.6118 249.198 81.6859 249.148 81.7533Z"
                    fill="#455A64"
                  />
                  <path
                    d="M229.647 170.961C229.647 170.961 226.42 140.397 226.233 129.103C226.047 117.809 231.313 106.663 231.313 106.663L251.938 105.806C251.938 105.806 256.017 117.263 256.089 122.084C256.232 131.439 253.604 140.674 253.906 148.095L254.595 170.98"
                    fill="#263238"
                  />
                  <path
                    d="M255.289 133.383C255.182 133.476 255.068 133.562 254.949 133.641L254.763 133.77L254.562 133.967C254.384 134.12 254.224 134.292 254.083 134.479C253.417 135.293 252.934 136.753 252.47 138.568C252.232 139.574 251.882 140.551 251.426 141.479C251.287 141.733 251.127 141.975 250.947 142.201C250.861 142.316 250.779 142.441 250.679 142.551L250.363 142.867C249.91 143.29 249.385 143.627 248.812 143.863C247.658 144.37 246.351 144.61 245.164 145.208C243.947 145.862 243.007 146.933 242.516 148.224C241.932 149.522 241.559 150.881 241.08 152.155C240.601 153.428 239.955 154.644 238.925 155.42C237.941 156.104 236.773 156.473 235.574 156.478C234.463 156.545 233.434 156.512 232.51 156.65C231.678 156.737 230.883 157.037 230.202 157.522C229.705 157.911 229.332 158.437 229.13 159.035C229.002 159.412 228.974 159.816 229.049 160.208C229.106 160.476 229.178 160.605 229.163 160.61C229.086 160.49 229.031 160.357 229.001 160.217C228.9 159.818 228.913 159.398 229.039 159.006C229.229 158.378 229.605 157.822 230.116 157.412C230.815 156.885 231.641 156.554 232.51 156.454C233.468 156.301 234.487 156.32 235.584 156.248C236.747 156.241 237.881 155.88 238.834 155.214C239.802 154.369 240.516 153.272 240.898 152.045C241.377 150.786 241.726 149.421 242.334 148.1C242.849 146.756 243.832 145.642 245.101 144.964C246.337 144.351 247.644 144.116 248.769 143.628C249.319 143.4 249.825 143.076 250.262 142.671L250.564 142.369C250.66 142.264 250.741 142.144 250.827 142.034C250.996 141.816 251.145 141.584 251.273 141.34C251.731 140.425 252.086 139.461 252.331 138.467C252.809 136.657 253.331 135.178 254.035 134.359C254.175 134.173 254.336 134.003 254.514 133.852C254.59 133.785 254.657 133.718 254.724 133.665L254.921 133.541C255.04 133.481 255.163 133.428 255.289 133.383Z"
                    fill="#FAFAFA"
                  />
                  <path
                    d="M255.414 119.24C255.436 119.375 255.446 119.511 255.443 119.647C255.441 120.043 255.393 120.436 255.299 120.82C254.887 122.221 254.077 123.472 252.968 124.421C252.236 125.094 251.433 125.686 250.574 126.187C249.65 126.733 248.63 127.255 247.582 127.849C246.48 128.439 245.455 129.161 244.527 129.998C243.576 130.942 242.792 132.042 242.21 133.249C241.623 134.473 240.953 135.655 240.204 136.787C239.823 137.315 239.383 137.797 238.892 138.223C238.408 138.635 237.876 138.987 237.308 139.272C236.279 139.777 235.207 140.189 234.105 140.502C233.08 140.818 232.123 141.101 231.289 141.46C230.533 141.761 229.814 142.146 229.145 142.609C228.641 142.958 228.188 143.375 227.799 143.849C227.474 144.259 227.202 144.71 226.99 145.189C227.024 145.057 227.069 144.927 227.124 144.802C227.281 144.44 227.482 144.099 227.723 143.787C228.105 143.293 228.556 142.858 229.063 142.494C229.736 142.015 230.46 141.613 231.222 141.297C232.145 140.921 233.086 140.594 234.042 140.316C235.129 139.995 236.186 139.582 237.202 139.08C237.741 138.799 238.247 138.459 238.71 138.065C239.183 137.645 239.607 137.173 239.974 136.658C240.713 135.531 241.376 134.357 241.961 133.144C242.562 131.909 243.372 130.789 244.355 129.831C245.299 128.981 246.344 128.251 247.467 127.657C248.52 127.068 249.54 126.556 250.464 126.015C251.321 125.53 252.123 124.956 252.858 124.301C253.958 123.38 254.774 122.167 255.213 120.801C255.336 120.29 255.403 119.766 255.414 119.24Z"
                    fill="#FAFAFA"
                  />
                  <path
                    d="M226.34 130.702C226.321 130.672 226.306 130.64 226.297 130.606C226.261 130.514 226.23 130.419 226.206 130.323C226.124 129.943 226.14 129.547 226.254 129.174C226.522 128.217 227.58 126.987 229.284 126.378C230.136 126.086 231.099 125.9 232.104 125.651C232.939 125.512 233.729 125.176 234.407 124.671C235.086 124.165 235.634 123.505 236.006 122.745C236.278 122.187 236.516 121.613 236.719 121.026C237.094 119.752 237.602 118.521 238.237 117.354C238.964 116.207 240.068 115.349 241.358 114.927C242.533 114.546 243.731 114.242 244.944 114.017C246.028 113.809 247.077 113.451 248.061 112.954C248.895 112.478 249.614 111.824 250.168 111.039C250.985 109.906 251.451 108.557 251.508 107.161C251.51 106.649 251.477 106.137 251.408 105.629C251.552 106.126 251.619 106.643 251.604 107.161C251.585 108.587 251.135 109.975 250.311 111.14C249.751 111.95 249.016 112.626 248.162 113.117C247.164 113.633 246.099 114.005 244.997 114.223C243.795 114.451 242.608 114.756 241.445 115.137C240.205 115.543 239.146 116.367 238.448 117.469C237.823 118.62 237.321 119.833 236.949 121.088C236.742 121.686 236.498 122.269 236.217 122.836C235.933 123.38 235.572 123.88 235.144 124.32C234.303 125.087 233.268 125.608 232.152 125.828C231.137 126.086 230.179 126.249 229.342 126.527C227.68 127.092 226.627 128.255 226.345 129.184C226.228 129.542 226.197 129.922 226.254 130.295C226.294 130.428 226.323 130.564 226.34 130.702Z"
                    fill="#FAFAFA"
                  />
                  <path
                    d="M253.643 156.554C253.663 156.654 253.674 156.755 253.677 156.856C253.686 157.146 253.655 157.436 253.586 157.718C253.285 158.756 252.648 159.665 251.776 160.303C251.193 160.767 250.549 161.148 249.861 161.433C249.128 161.744 248.319 161.993 247.467 162.256C246.582 162.515 245.717 162.835 244.877 163.214C244.004 163.631 243.222 164.215 242.574 164.933C241.875 165.66 241.272 166.46 240.602 167.169C239.96 167.855 239.216 168.436 238.395 168.892C236.997 169.655 235.433 170.062 233.841 170.079C232.775 170.091 231.715 169.914 230.71 169.558C230.438 169.464 230.172 169.35 229.916 169.218C229.822 169.179 229.734 169.129 229.652 169.069C229.749 169.096 229.843 169.129 229.935 169.17C230.198 169.282 230.466 169.381 230.739 169.467C231.742 169.781 232.79 169.928 233.841 169.902C235.398 169.862 236.922 169.446 238.284 168.691C239.08 168.24 239.802 167.67 240.424 167.001C241.08 166.302 241.679 165.507 242.392 164.76C243.078 164.016 243.905 163.414 244.824 162.989C245.677 162.608 246.555 162.288 247.453 162.031C248.295 161.773 249.1 161.553 249.846 161.237C250.514 160.963 251.142 160.601 251.714 160.16C252.571 159.554 253.211 158.687 253.538 157.689C253.608 157.315 253.644 156.935 253.643 156.554Z"
                    fill="#FAFAFA"
                  />
                  <path
                    d="M251.292 93.1002L247.299 93.1959C247.145 94.0011 246.84 94.7696 246.399 95.4605C243.048 89.6675 240.477 81.9116 239.835 78.7948C239.931 78.4836 240.041 78.1389 240.18 77.7559C240.279 77.1742 240.261 76.5784 240.127 76.0037C240.012 75.3095 239.821 74.3759 239.763 73.945C239.586 72.6236 239.371 72.4177 238.911 72.5662C238.289 72.772 239.17 76.267 238.657 76.3436C238.38 76.3819 238.045 75.185 237.949 74.2035C237.853 73.2221 237.403 70.1963 237.082 69.9952C236.604 69.6984 236.187 70.1676 236.311 71.1442C236.436 72.1209 236.584 75.0892 236.067 75.1323C235.55 75.1754 235.11 70.158 235.11 70.158C235.11 70.158 235.191 69.0664 234.588 69.0904C233.506 69.1382 234.353 74.4237 234.444 74.9264C234.511 75.2712 233.966 75.3382 233.899 74.96C233.831 74.5817 233.583 69.9473 232.462 69.9856C231.61 69.9856 233.118 74.3376 232.639 75.343C232.161 76.3484 231.835 71.9342 231.026 71.9916C230.724 72.0156 230.499 72.073 231.055 74.5674C231.587 76.5492 232.226 78.5006 232.97 80.413C234.253 87.3311 239.883 109.464 248.707 105.414C253.647 103.145 255.649 93.1002 255.649 93.1002H251.292Z"
                    fill="#B78876"
                  />
                  <path
                    d="M234.271 75.2612C234.309 75.2707 234.348 75.2707 234.386 75.2612C234.444 75.2435 234.493 75.2059 234.526 75.155C234.558 75.1041 234.572 75.0433 234.563 74.9835C234.563 74.6866 234.506 74.2558 234.439 73.6956C234.327 73.0205 234.253 72.3396 234.218 71.6561C234.218 71.2539 234.218 70.8231 234.242 70.3682C234.25 70.137 234.274 69.9066 234.314 69.6788C234.353 69.4634 234.496 69.2001 234.664 69.2431H234.692C234.86 69.2431 234.994 69.3676 235.047 69.5687C235.106 69.7771 235.129 69.9941 235.114 70.2102C235.212 71.551 235.383 72.8855 235.626 74.2079C235.664 74.385 235.703 74.567 235.76 74.7489C235.786 74.842 235.818 74.9332 235.856 75.0218C235.88 75.0711 235.908 75.119 235.937 75.1654C235.959 75.2004 235.988 75.2299 236.023 75.2515C236.058 75.2731 236.097 75.2863 236.138 75.2899C236.208 75.2822 236.274 75.254 236.328 75.2088C236.381 75.1637 236.42 75.1036 236.44 75.0361C236.481 74.9425 236.512 74.8445 236.531 74.7441C236.568 74.5511 236.594 74.3561 236.608 74.16C236.651 73.3623 236.64 72.5624 236.574 71.7662C236.513 71.3687 236.497 70.9656 236.526 70.5645C236.544 70.3913 236.628 70.2316 236.761 70.1193C236.791 70.101 236.826 70.0895 236.861 70.0853C236.897 70.0812 236.933 70.0846 236.967 70.0953C237.007 70.1051 237.046 70.1212 237.081 70.1432C237.106 70.1614 237.124 70.1864 237.134 70.215C237.285 70.6033 237.396 71.0059 237.464 71.4167C237.551 71.838 237.622 72.2737 237.69 72.7094C237.757 73.145 237.819 73.5855 237.871 74.0308C237.912 74.4902 237.986 74.9462 238.092 75.3952C238.148 75.6248 238.22 75.8503 238.307 76.0703C238.356 76.1934 238.424 76.3081 238.508 76.4102C238.541 76.4526 238.584 76.485 238.634 76.5037C238.684 76.5223 238.738 76.5264 238.791 76.5155C238.839 76.4995 238.883 76.4713 238.917 76.4335C238.951 76.3958 238.976 76.3498 238.987 76.3001C239.044 76.0554 239.061 75.8034 239.04 75.5532C239.04 75.3138 239.011 75.0744 238.987 74.8446C238.953 74.4425 238.915 74.0451 238.901 73.6525C238.889 73.4596 238.889 73.2661 238.901 73.0732C238.91 72.9878 238.931 72.9041 238.963 72.8243C238.973 72.7979 238.988 72.7736 239.006 72.7525H239.068C239.384 72.6232 239.49 73.0637 239.576 73.4179C239.662 73.7722 239.696 74.1744 239.772 74.5526C239.897 75.3043 240.059 76.0559 240.141 76.774C240.196 77.1179 240.183 77.4693 240.102 77.8082C239.988 78.1529 239.873 78.4928 239.763 78.8327V78.8662V78.895C240.323 81.247 241.038 83.5596 241.903 85.8178C242.659 87.8621 243.42 89.6479 244.086 91.0842C244.751 92.5205 245.354 93.6456 245.766 94.402L246.245 95.259C246.297 95.3611 246.359 95.4574 246.432 95.5462C246.391 95.4399 246.342 95.3374 246.283 95.2398L245.804 94.3637C245.412 93.5929 244.847 92.4487 244.196 91.0124C243.545 89.5761 242.807 87.7903 242.07 85.746C241.227 83.4912 240.526 81.1854 239.973 78.8423V78.9093C240.083 78.5742 240.193 78.2343 240.308 77.8943C240.408 77.5212 240.428 77.1313 240.366 76.7501C240.28 75.9985 240.122 75.2707 239.997 74.5143C239.925 74.1409 239.877 73.7579 239.801 73.3653C239.796 73.1636 239.762 72.9637 239.7 72.7716C239.646 72.6548 239.553 72.5602 239.437 72.5035C239.314 72.4633 239.182 72.4633 239.059 72.5035H238.982C238.942 72.5165 238.904 72.5377 238.872 72.5657C238.819 72.6108 238.778 72.6684 238.752 72.7333C238.708 72.8369 238.681 72.9468 238.671 73.0589C238.657 73.2661 238.657 73.474 238.671 73.6813C238.671 74.0834 238.728 74.4856 238.762 74.8877C238.762 75.1223 238.8 75.3665 238.81 75.5819C238.829 75.7979 238.818 76.0154 238.776 76.2283C238.776 76.2761 238.738 76.2666 238.776 76.2905L238.748 76.2618C238.687 76.1835 238.638 76.0963 238.604 76.0032C238.52 75.7961 238.452 75.5834 238.398 75.3665C238.293 74.9305 238.221 74.4872 238.183 74.0403C238.132 73.5903 238.069 73.145 237.996 72.7046C237.929 72.2641 237.852 71.8332 237.766 71.4024C237.694 70.9638 237.572 70.5349 237.402 70.1241C237.369 70.0554 237.318 69.9974 237.254 69.9565C237.198 69.9241 237.139 69.8984 237.077 69.8799C237.008 69.862 236.937 69.8578 236.867 69.8677C236.798 69.8776 236.73 69.9012 236.67 69.9373C236.571 70.0111 236.489 70.1045 236.428 70.2116C236.367 70.3187 236.329 70.4372 236.315 70.5597C236.284 70.7773 236.284 70.9981 236.315 71.2156C236.315 71.4215 236.363 71.6226 236.378 71.8237C236.444 72.607 236.459 73.3939 236.421 74.1792C236.41 74.3657 236.386 74.5513 236.349 74.7345C236.335 74.8201 236.311 74.9037 236.277 74.9835C236.265 75.015 236.247 75.0442 236.224 75.0697C236.224 75.1127 236.191 75.0697 236.196 75.1271C236.196 75.0792 236.196 75.1271 236.196 75.0649C236.175 75.0325 236.155 74.999 236.138 74.9643C236.105 74.8877 236.076 74.8016 236.047 74.7202C235.995 74.5478 235.956 74.3707 235.918 74.1983C235.668 72.8873 235.488 71.5641 235.377 70.2342C235.391 69.9935 235.364 69.7521 235.296 69.5208C235.264 69.4002 235.199 69.2907 235.109 69.2048C235.062 69.1596 235.007 69.1243 234.946 69.1013C234.885 69.0782 234.82 69.0679 234.755 69.0708H234.783C234.702 69.0589 234.62 69.0712 234.546 69.1062C234.472 69.1411 234.409 69.197 234.367 69.2671C234.296 69.3813 234.247 69.508 234.223 69.6405C234.183 69.8779 234.161 70.1179 234.156 70.3587C234.156 70.8374 234.156 71.2539 234.156 71.6609C234.202 72.3487 234.29 73.033 234.42 73.71C234.501 74.2653 234.563 74.6962 234.592 74.9883C234.601 75.0394 234.592 75.0922 234.567 75.1375C234.542 75.1829 234.501 75.2181 234.453 75.2372C234.309 75.2516 234.266 75.2564 234.271 75.2612Z"
                    fill="#A36957"
                  />
                  <path
                    d="M203.09 99.6924C202.156 99.6725 201.224 99.7804 200.318 100.013C197.843 100.664 193.578 103.25 193.4 106.443H196.503C196.503 106.443 194.765 110.139 195.272 109.794C196.599 108.904 199.232 106.227 199.232 106.227L203.09 99.6924Z"
                    fill="#B78876"
                  />
                  <path
                    d="M245.38 44.0459C245.308 44.0459 245.031 41.4893 244.753 38.3008C244.475 35.1122 244.303 32.5557 244.37 32.5557C244.437 32.5557 244.719 35.1122 244.997 38.3008C245.275 41.4893 245.447 44.0459 245.38 44.0459Z"
                    fill="#263238"
                  />
                  <path
                    d="M258.982 32.7524C259.035 32.7907 256.942 35.8309 254.304 39.5413C251.666 43.2517 249.479 46.2439 249.421 46.1865C249.364 46.129 251.461 43.108 254.099 39.3976C256.737 35.6872 258.924 32.7141 258.982 32.7524Z"
                    fill="#263238"
                  />
                  <path
                    d="M264.631 46.531C264.631 46.5981 262.198 47.1582 259.173 47.7806C256.147 48.403 253.677 48.853 253.662 48.786C253.648 48.719 256.089 48.1588 259.12 47.5364C262.151 46.914 264.597 46.464 264.631 46.531Z"
                    fill="#263238"
                  />
                  <path
                    d="M101.816 112.289L84.8683 199.327L82.666 210.722L195.653 210.176C200.728 210.152 205.229 205.647 206.852 198.954L226.893 116.784C228.133 111.705 225.413 106.419 221.564 106.424L107.179 106.544C104.689 106.539 102.458 108.894 101.816 112.289Z"
                    fill="#5F9CB1"
                  />
                  <g opacity="0.5">
                    <path
                      d="M101.816 112.289L84.8683 199.327L82.666 210.722L195.653 210.176C200.728 210.152 205.229 205.647 206.852 198.954L226.893 116.784C228.133 111.705 225.413 106.419 221.564 106.424L107.179 106.544C104.689 106.539 102.458 108.894 101.816 112.289Z"
                      fill="black"
                    />
                  </g>
                  <path
                    d="M184.829 193.419L172.86 96.992C172.382 93.0423 169.227 90.0931 165.507 90.1075L139.271 90.1889C138.296 90.1999 137.333 90.4093 136.442 90.8044C135.55 91.1995 134.749 91.7719 134.086 92.4869L121.638 105.734L48.6748 106.127C44.2175 106.151 40.7896 110.373 41.3785 115.113L52.4905 204.234C52.9693 208.179 56.1243 211.124 59.8347 211.119L187.017 210.865C201.179 211.157 202.534 206.978 202.534 206.978C186.275 210.573 184.829 193.443 184.829 193.419Z"
                    fill="#5F9CB1"
                  />
                  <g opacity="0.5">
                    <path
                      d="M129.988 174.135L125.699 178.741L92.6641 149.019L96.9538 144.414L129.988 174.135Z"
                      fill="white"
                    />
                    <path
                      d="M123.904 143.394L128.643 147.66L98.7543 179.761L94.0098 175.495L123.904 143.394Z"
                      fill="white"
                    />
                  </g>
                  <path
                    d="M202.991 49.6859C202.836 49.6205 202.703 49.5125 202.607 49.3743C202.511 49.2361 202.457 49.0735 202.45 48.9055L202.259 44.4626C202.252 44.3245 202.277 44.1868 202.333 44.0603C202.389 43.9338 202.473 43.822 202.579 43.7337C202.686 43.6455 202.811 43.5832 202.946 43.5518C203.081 43.5204 203.221 43.5208 203.355 43.5529C203.726 43.6329 204.109 43.6364 204.481 43.5631C204.853 43.4898 205.206 43.3414 205.519 43.1268C205.807 42.9446 206.054 42.7053 206.246 42.4237C206.438 42.1421 206.57 41.8241 206.635 41.4895C206.678 41.1506 206.653 40.8065 206.561 40.4776C206.469 40.1486 206.311 39.8415 206.098 39.5744C205.874 39.2706 205.592 39.0139 205.268 38.8192C204.944 38.6245 204.586 38.4956 204.212 38.4398C203.459 38.3979 202.713 38.6114 202.096 39.0459C201.479 39.4803 201.027 40.1102 200.813 40.8336C200.741 41.0528 200.588 41.2359 200.385 41.3449C200.182 41.4538 199.944 41.4802 199.722 41.4185C199.5 41.3568 199.31 41.2118 199.192 41.0136C199.074 40.8155 199.037 40.5795 199.089 40.3548C199.415 39.217 200.123 38.2261 201.093 37.5486C202.063 36.8711 203.238 36.5484 204.418 36.6348C205.032 36.7167 205.624 36.9212 206.158 37.2362C206.691 37.5512 207.156 37.9703 207.525 38.4685C207.884 38.9303 208.146 39.4593 208.296 40.0243C208.447 40.5892 208.483 41.1786 208.401 41.7576C208.292 42.3357 208.066 42.8854 207.737 43.3729C207.408 43.8603 206.982 44.2752 206.486 44.5918C205.768 45.0754 204.929 45.349 204.064 45.3818L204.212 48.8097C204.218 48.9603 204.185 49.1099 204.117 49.2446C204.05 49.3793 203.949 49.4947 203.825 49.5801C203.701 49.6656 203.557 49.7183 203.407 49.7335C203.257 49.7486 203.106 49.7256 202.967 49.6667L202.991 49.6859Z"
                    fill="#5F9CB1"
                  />
                  <path
                    d="M204.303 51.5049C204.313 51.6494 204.28 51.7938 204.208 51.9196C204.136 52.0454 204.029 52.147 203.899 52.2116C203.769 52.2762 203.623 52.3008 203.479 52.2824C203.336 52.264 203.2 52.2033 203.091 52.1081C202.982 52.0129 202.903 51.8875 202.865 51.7476C202.827 51.6077 202.832 51.4597 202.878 51.3223C202.924 51.185 203.01 51.0644 203.125 50.9759C203.24 50.8873 203.378 50.8348 203.523 50.825C203.619 50.8179 203.715 50.8298 203.806 50.8602C203.898 50.8906 203.982 50.9388 204.055 51.002C204.127 51.0652 204.187 51.1422 204.229 51.2286C204.272 51.3149 204.297 51.4088 204.303 51.5049Z"
                    fill="#5F9CB1"
                  />
                  <path
                    d="M187.608 43.4182C187.629 43.3235 187.643 43.2275 187.651 43.1309C187.651 42.9203 187.704 42.6522 187.742 42.274C187.789 41.8096 187.868 41.349 187.977 40.8951C188.039 40.627 188.072 40.3302 188.168 40.0286C188.264 39.727 188.36 39.4014 188.465 39.0711C189.019 37.4343 189.827 35.8947 190.859 34.5085C192.211 32.7134 193.925 31.2226 195.891 30.1326C197.009 29.5019 198.201 29.0099 199.438 28.6676C200.774 28.3135 202.15 28.1333 203.532 28.1314C204.26 28.1197 204.987 28.1581 205.71 28.2463C206.079 28.2846 206.442 28.3803 206.811 28.4426C207.184 28.5064 207.552 28.596 207.912 28.7107C209.421 29.1324 210.857 29.7831 212.168 30.6401C215.085 32.5318 217.307 35.3215 218.498 38.5875C219.139 40.337 219.463 42.1868 219.455 44.0502C219.475 45.9697 219.136 47.876 218.455 49.6708L218.239 50.2166L218.21 50.2884L218.239 50.3602C219.441 53.1227 220.633 55.8373 221.758 58.4656L221.959 58.2358L214.778 55.483L214.692 55.4495L214.62 55.5165C212.72 57.3572 210.394 58.6993 207.85 59.4232C205.676 60.0217 203.4 60.1523 201.172 59.8066C198.943 59.4608 196.814 58.6464 194.924 57.4172C193.375 56.4018 192.01 55.131 190.888 53.6589C189.26 51.5101 188.206 48.9829 187.823 46.3147C187.766 45.8359 187.718 45.4338 187.675 45.0699C187.632 44.7061 187.675 44.4092 187.651 44.1555C187.627 43.9018 187.651 43.7342 187.651 43.5953C187.675 43.5917 187.697 43.5792 187.712 43.5603C187.727 43.5414 187.734 43.5176 187.732 43.4935C187.73 43.4694 187.72 43.4469 187.702 43.4305C187.684 43.4141 187.661 43.4049 187.637 43.4049C187.613 43.4049 187.589 43.4141 187.572 43.4305C187.554 43.4469 187.543 43.4694 187.541 43.4935C187.539 43.5176 187.547 43.5414 187.562 43.5603C187.577 43.5792 187.599 43.5917 187.622 43.5953C187.622 43.7342 187.622 43.9209 187.622 44.1555C187.622 44.3901 187.622 44.7157 187.622 45.0795C187.622 45.4434 187.704 45.8599 187.752 46.3339C187.909 47.4854 188.183 48.6179 188.57 49.7139C189.118 51.1613 189.856 52.5296 190.763 53.7834C191.891 55.2817 193.265 56.577 194.828 57.6135C196.741 58.8734 198.901 59.712 201.164 60.0735C203.426 60.435 205.74 60.3113 207.951 59.7104C210.525 58.9791 212.88 57.6241 214.806 55.7654L214.648 55.799L221.83 58.5662L222.189 58.705L222.031 58.3364C220.891 55.708 219.714 52.9982 218.517 50.231V50.3698L218.737 49.8097C219.436 47.9758 219.783 46.0269 219.762 44.0645C219.777 42.1616 219.452 40.2713 218.804 38.4822C217.587 35.1511 215.316 32.3083 212.336 30.3864C210.991 29.5094 209.518 28.8471 207.97 28.4234C207.603 28.3075 207.229 28.2195 206.849 28.1601C206.476 28.0931 206.107 27.9973 205.734 27.9638C205.002 27.8729 204.264 27.8313 203.527 27.8393C202.123 27.8453 200.726 28.0352 199.371 28.4043C198.117 28.7604 196.91 29.2651 195.776 29.9076C193.791 31.0243 192.066 32.5502 190.715 34.384C189.687 35.7932 188.89 37.3577 188.355 39.0184C188.254 39.3631 188.159 39.6935 188.072 39.9759C187.996 40.2645 187.936 40.557 187.891 40.8521C187.788 41.309 187.721 41.7732 187.689 42.2405C187.661 42.6091 187.642 42.8916 187.627 43.1022C187.607 43.2063 187.601 43.3125 187.608 43.4182Z"
                    fill="#263238"
                  />
                </svg>
              </p>
            ) : (
              comments
                .filter((item) => Array.isArray(item?.Comments) && item?.Comments?.length > 0)
                .map((item, index) => (
                  <CommentsCommponent key={index} comments={item} user={user} />
                ))
            )
          ) : (
            <div
              className="my-3 w-100 d-flex justify-content-center"
              style={{ textAlign: 'center' }}
            >
              <CircularProgress style={{ color: '#102dff' }} />
              <div style={{ color: 'white' }}></div>
            </div>
          )}
        </Offcanvas.Body>
      </Offcanvas>

      <Tooltip
        title={
          !isClickable
            ? `You can't access this lead before ${user?.sales?.name} confirm Receive`
            : ''
        }
      >
        <div
          className="mx-2 my-1"
          onClick={() => {
            if (!isClickable) return;

            handleShow();
            setIsChecked(!isChecked);
          }}
          style={{
            color: isClickable ? '#666' : '#888',
            padding: '0',
            cursor: isClickable ? 'pointer' : 'not-allowed',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            textDecoration: 'underline',
            textUnderlineOffset: '3px',
            textDecorationColor: '#666',
            textDecorationThickness: '1px',
          }}
        >
          {user.name}
        </div>
      </Tooltip>
    </div>
  );
};
